var jo = Object.defineProperty;
var _o = (e, t, r) => t in e ? jo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var N = (e, t, r) => _o(e, typeof t != "symbol" ? t + "" : t, r);
import Ya, { ref as ae, computed as At, unref as Ro, getCurrentScope as Co, onScopeDispose as Fo, watchEffect as Wo, getCurrentInstance as Lo, onMounted as Uo } from "vue";
import Go, { isAxiosError as qo } from "axios";
function Gc(e = 0) {
  const t = ae(e < 0 ? 0 : e), r = ae(null), n = () => {
    r.value !== null && (clearInterval(r.value), r.value = null);
  }, i = (f = 0) => {
    f > 0 && (t.value = f), !r.value && (r.value = window.setInterval(() => {
      t.value--, t.value === 0 && n();
    }, 1e3));
  }, u = () => {
    n(), t.value = e;
  }, c = At(() => r.value !== null);
  return {
    timeLeft: t,
    startTimer: i,
    stopTimer: n,
    resetTimer: u,
    isRunning: c
  };
}
var rt = /* @__PURE__ */ ((e) => (e.Mobile = "mobile", e.Tablet = "tablet", e.Desktop = "desktop", e))(rt || {});
Ya.util.warn;
function $o(e) {
  return Co() ? (Fo(e), !0) : !1;
}
function fr(e) {
  return typeof e == "function" ? e() : Ro(e);
}
const Yo = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
function Bo(e, t) {
  var r;
  if (typeof e == "number")
    return e + t;
  const n = ((r = e.match(/^-?\d+\.?\d*/)) == null ? void 0 : r[0]) || "", i = e.slice(n.length), u = Number.parseFloat(n) + t;
  return Number.isNaN(u) ? e : u + i;
}
Ya.util.warn;
const Ba = Yo ? window : void 0;
function zo() {
  const e = ae(!1);
  return Lo() && Uo(() => {
    e.value = !0;
  }, void 0), e;
}
function Ho(e) {
  const t = zo();
  return At(() => (t.value, !!e()));
}
function $t(e, t = {}) {
  const { window: r = Ba } = t, n = Ho(() => r && "matchMedia" in r && typeof r.matchMedia == "function");
  let i;
  const u = ae(!1), c = (g) => {
    u.value = g.matches;
  }, f = () => {
    i && ("removeEventListener" in i ? i.removeEventListener("change", c) : i.removeListener(c));
  }, b = Wo(() => {
    n.value && (f(), i = r.matchMedia(fr(e)), "addEventListener" in i ? i.addEventListener("change", c) : i.addListener(c), u.value = i.matches);
  });
  return $o(() => {
    b(), f(), i = void 0;
  }), u;
}
function Vo(e, t = {}) {
  function r(y, E) {
    let p = fr(e[fr(y)]);
    return E != null && (p = Bo(p, E)), typeof p == "number" && (p = `${p}px`), p;
  }
  const { window: n = Ba, strategy: i = "min-width" } = t;
  function u(y) {
    return n ? n.matchMedia(y).matches : !1;
  }
  const c = (y) => $t(() => `(min-width: ${r(y)})`, t), f = (y) => $t(() => `(max-width: ${r(y)})`, t), b = Object.keys(e).reduce((y, E) => (Object.defineProperty(y, E, {
    get: () => i === "min-width" ? c(E) : f(E),
    enumerable: !0,
    configurable: !0
  }), y), {});
  function g() {
    const y = Object.keys(e).map((E) => [E, c(E)]);
    return At(() => y.filter(([, E]) => E.value).map(([E]) => E));
  }
  return Object.assign(b, {
    greaterOrEqual: c,
    smallerOrEqual: f,
    greater(y) {
      return $t(() => `(min-width: ${r(y, 0.1)})`, t);
    },
    smaller(y) {
      return $t(() => `(max-width: ${r(y, -0.1)})`, t);
    },
    between(y, E) {
      return $t(() => `(min-width: ${r(y)}) and (max-width: ${r(E, -0.1)})`, t);
    },
    isGreater(y) {
      return u(`(min-width: ${r(y, 0.1)})`);
    },
    isGreaterOrEqual(y) {
      return u(`(min-width: ${r(y)})`);
    },
    isSmaller(y) {
      return u(`(max-width: ${r(y, -0.1)})`);
    },
    isSmallerOrEqual(y) {
      return u(`(max-width: ${r(y)})`);
    },
    isInBetween(y, E) {
      return u(`(min-width: ${r(y)}) and (max-width: ${r(E, -0.1)})`);
    },
    current: g,
    active() {
      const y = g();
      return At(() => y.value.length === 0 ? "" : y.value.at(-1));
    }
  });
}
const ve = {
  [rt.Desktop]: 1280,
  [rt.Tablet]: 780,
  [rt.Mobile]: 0
}, qc = () => {
  const e = Vo({
    [rt.Mobile]: ve[rt.Mobile],
    [rt.Tablet]: ve[rt.Tablet],
    [rt.Desktop]: ve[rt.Desktop]
  }), t = () => e.active(), r = (E) => t().value === E, n = (E) => e.smaller(E), i = (E) => e.smallerOrEqual(E), u = (E, p) => e.between(E, p), c = (E) => e.greater(E), f = (E) => e.greaterOrEqual(E), b = At(() => r(rt.Mobile)), g = At(() => r(rt.Tablet)), y = At(() => r(rt.Desktop));
  return {
    getCurrent: t,
    isActive: r,
    isSmaller: n,
    isSmallerOrEqual: i,
    isInBetween: u,
    isGreater: c,
    isGreaterOrEqual: f,
    isMobile: b,
    isTablet: g,
    isDesktop: y
  };
};
class be extends Error {
  constructor(r, { status: n, data: i, isTimeout: u = !1, isCanceled: c = !1, config: f = {} } = {}) {
    super(r);
    N(this, "status");
    N(this, "data");
    N(this, "isTimeout");
    N(this, "isCanceled");
    N(this, "config");
    this.name = "NetworkError", this.status = n, this.data = i, this.isTimeout = u, this.isCanceled = c, this.config = f;
  }
}
function Ko(e) {
  var t, r;
  if (qo(e) || e != null && e.isAxiosError) {
    const n = e.code === "ECONNABORTED", i = e.code === "ERR_CANCELED" || e.message === "canceled";
    return new be(e.message || "An error occurred", {
      status: (t = e.response) == null ? void 0 : t.status,
      data: (r = e.response) == null ? void 0 : r.data,
      config: e.config,
      isTimeout: n,
      isCanceled: i
    });
  }
  return e instanceof DOMException && e.name === "AbortError" ? new be("Request was aborted", {
    isCanceled: !0
  }) : new be("Unknown network error occurred");
}
class Qo {
  constructor(t = "") {
    N(this, "axiosInstance");
    N(this, "requestCallbacks", []);
    N(this, "requestInterceptors", /* @__PURE__ */ new Map());
    N(this, "responseInterceptors", /* @__PURE__ */ new Map());
    this.axiosInstance = Go.create({
      baseURL: t,
      withCredentials: !0,
      timeout: 1e4
    });
  }
  async request({
    method: t,
    url: r,
    data: n,
    config: i = {}
  }) {
    try {
      return this.requestCallbacks.forEach(
        (c) => c({
          method: t,
          url: r,
          data: n,
          config: i
        })
      ), (await this.axiosInstance.request({
        method: t,
        url: r,
        data: n,
        ...i
      })).data;
    } catch (u) {
      throw Ko(u);
    }
  }
  async get(t, r) {
    return this.request({ method: "get", url: t, config: r });
  }
  async post(t, r, n) {
    return this.request({ method: "post", url: t, data: r, config: n });
  }
  async put(t, r, n) {
    return this.request({ method: "put", url: t, data: r, config: n });
  }
  async delete(t, r) {
    return this.request({ method: "delete", url: t, config: r });
  }
  async patch(t, r, n) {
    return this.request({ method: "patch", url: t, data: r, config: n });
  }
  async head(t, r) {
    return this.request({ method: "head", url: t, config: r });
  }
  async options(t, r) {
    return this.request({ method: "options", url: t, config: r });
  }
  setHeader(t, r) {
    this.axiosInstance.defaults.headers.common[t] = r;
  }
  removeHeader(t) {
    delete this.axiosInstance.defaults.headers.common[t];
  }
  addRequestCallback(t) {
    return this.requestCallbacks.push(t), this.requestCallbacks.length - 1;
  }
  removeRequestCallback(t) {
    this.requestCallbacks.splice(t, 1);
  }
  addRequestInterceptor(t, r) {
    const n = this.axiosInstance.interceptors.request.use(t, r);
    return this.requestInterceptors.set(n, n), n;
  }
  removeRequestInterceptor(t) {
    this.axiosInstance.interceptors.request.eject(t), this.requestInterceptors.delete(t);
  }
  addResponseInterceptor(t, r) {
    const n = this.axiosInstance.interceptors.response.use(t, r);
    return this.responseInterceptors.set(n, n), n;
  }
  removeResponseInterceptor(t) {
    this.axiosInstance.interceptors.response.eject(t), this.responseInterceptors.delete(t);
  }
}
const $c = new Qo();
class Lt extends Error {
  constructor(r, { serviceName: n, providerName: i, eventData: u, cause: c } = {}) {
    super(r, { cause: c });
    N(this, "serviceName");
    N(this, "providerName");
    N(this, "eventData");
    N(this, "cause");
    this.name = "AnalyticsError", this.serviceName = n, this.providerName = i, this.eventData = u, this.cause = c, c instanceof Error && (this.stack = c.stack), Object.setPrototypeOf(this, new.target.prototype);
  }
}
var V = /* @__PURE__ */ ((e) => (e.ADRIVER = "adriver", e.TRACKER = "tracker", e.METRIKA = "metrika", e.ERROR_LOGGER = "errorLogger", e.VK = "vk", e))(V || {});
class Jt {
  constructor() {
    N(this, "isStartedInit", !1);
    N(this, "queue", []);
    N(this, "isInitialized", !1);
    N(this, "initTimeoutId", null);
    N(this, "startedAt", null);
    N(this, "timeoutMS", Wa);
  }
  createQueue() {
    return [];
  }
  baseInit(t) {
    this.isStartedInit = !0, !this.isInitialized && (this.timeoutMS = t ?? Wa, this.queue = this.createQueue(), this.startedAt = Date.now(), this.install(), this.waitForInitialization());
  }
  waitForInitialization() {
    if (this.initTimeoutId && clearTimeout(this.initTimeoutId), this.isInstalled()) {
      this.isInitialized = !0, this.flushQueue(), this.clearQueue();
      return;
    }
    this.isTooLongInit || (this.initTimeoutId = setTimeout(this.waitForInitialization.bind(this), Nc));
  }
  flushQueue() {
    this.isInitialized && this.queue.forEach((t) => t == null ? void 0 : t());
  }
  clearQueue() {
    this.queue = this.createQueue();
  }
  get isTooLongInit() {
    return !!this.startedAt && Date.now() - this.startedAt >= this.timeoutMS;
  }
  enqueueOrExecute(t) {
    this.isInitialized ? t() : this.queue.push(t);
  }
}
const za = 6048e5, Xo = 864e5, ie = 6e4, pr = 36e5, Nr = Symbol.for("constructDateFrom");
function K(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Nr in e ? e[Nr](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function R(e, t) {
  return K(t || e, e);
}
function Kt(e, t, r) {
  const n = R(e, r == null ? void 0 : r.in);
  return isNaN(t) ? K(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function yr(e, t, r) {
  const n = R(e, r == null ? void 0 : r.in);
  if (isNaN(t)) return K(e, NaN);
  if (!t)
    return n;
  const i = n.getDate(), u = K(e, n.getTime());
  u.setMonth(n.getMonth() + t + 1, 0);
  const c = u.getDate();
  return i >= c ? u : (n.setFullYear(
    u.getFullYear(),
    u.getMonth(),
    i
  ), n);
}
function Yt(e, t, r) {
  const {
    years: n = 0,
    months: i = 0,
    weeks: u = 0,
    days: c = 0,
    hours: f = 0,
    minutes: b = 0,
    seconds: g = 0
  } = t, y = R(e, r == null ? void 0 : r.in), E = i || n ? yr(y, i + n * 12) : y, p = c || u ? Kt(E, c + u * 7) : E, d = b + f * 60, k = (g + d * 60) * 1e3;
  return K(e, +p + k);
}
let Jo = {};
function se() {
  return Jo;
}
function Mt(e, t) {
  var f, b, g, y;
  const r = se(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((b = (f = t == null ? void 0 : t.locale) == null ? void 0 : f.options) == null ? void 0 : b.weekStartsOn) ?? r.weekStartsOn ?? ((y = (g = r.locale) == null ? void 0 : g.options) == null ? void 0 : y.weekStartsOn) ?? 0, i = R(e, t == null ? void 0 : t.in), u = i.getDay(), c = (u < n ? 7 : 0) + u - n;
  return i.setDate(i.getDate() - c), i.setHours(0, 0, 0, 0), i;
}
function oe(e, t) {
  return Mt(e, { ...t, weekStartsOn: 1 });
}
function Ha(e, t) {
  const r = R(e, t == null ? void 0 : t.in), n = r.getFullYear(), i = K(r, 0);
  i.setFullYear(n + 1, 0, 4), i.setHours(0, 0, 0, 0);
  const u = oe(i), c = K(r, 0);
  c.setFullYear(n, 0, 4), c.setHours(0, 0, 0, 0);
  const f = oe(c);
  return r.getTime() >= u.getTime() ? n + 1 : r.getTime() >= f.getTime() ? n : n - 1;
}
function jr(e) {
  const t = R(e), r = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return r.setUTCFullYear(t.getFullYear()), +e - +r;
}
function st(e, ...t) {
  const r = K.bind(
    null,
    e || t.find((n) => typeof n == "object")
  );
  return t.map(r);
}
function Xt(e, t) {
  const r = R(e, t == null ? void 0 : t.in);
  return r.setHours(0, 0, 0, 0), r;
}
function Va(e, t, r) {
  const [n, i] = st(
    r == null ? void 0 : r.in,
    e,
    t
  ), u = Xt(n), c = Xt(i), f = +u - jr(u), b = +c - jr(c);
  return Math.round((f - b) / Xo);
}
function Zo(e, t) {
  const r = Ha(e, t), n = K(e, 0);
  return n.setFullYear(r, 0, 4), n.setHours(0, 0, 0, 0), oe(n);
}
function ti(e, t, r) {
  const n = R(e, r == null ? void 0 : r.in);
  return n.setTime(n.getTime() + t * ie), n;
}
function ei(e, t, r) {
  return yr(e, t * 12, r);
}
function Qt(e, t) {
  const r = +R(e) - +R(t);
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function ri(e, t, r) {
  const [n, i] = st(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return +Xt(n) == +Xt(i);
}
function ni(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Vt(e) {
  return !(!ni(e) && typeof e != "number" || isNaN(+R(e)));
}
function ai(e, t, r) {
  const [n, i] = st(
    r == null ? void 0 : r.in,
    e,
    t
  ), u = n.getFullYear() - i.getFullYear(), c = n.getMonth() - i.getMonth();
  return u * 12 + c;
}
function oi(e, t, r) {
  const [n, i] = st(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return n.getFullYear() - i.getFullYear();
}
function Ka(e, t, r) {
  const [n, i] = st(
    r == null ? void 0 : r.in,
    e,
    t
  ), u = _r(n, i), c = Math.abs(
    Va(n, i)
  );
  n.setDate(n.getDate() - u * c);
  const f = +(_r(n, i) === -u), b = u * (c - f);
  return b === 0 ? 0 : b;
}
function _r(e, t) {
  const r = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function mr(e) {
  return (t) => {
    const n = (e ? Math[e] : Math.trunc)(t);
    return n === 0 ? 0 : n;
  };
}
function ii(e, t, r) {
  const [n, i] = st(
    r == null ? void 0 : r.in,
    e,
    t
  ), u = (+n - +i) / pr;
  return mr(r == null ? void 0 : r.roundingMethod)(u);
}
function Qa(e, t) {
  return +R(e) - +R(t);
}
function si(e, t, r) {
  const n = Qa(e, t) / ie;
  return mr(r == null ? void 0 : r.roundingMethod)(n);
}
function Xa(e, t) {
  const r = R(e, t == null ? void 0 : t.in);
  return r.setHours(23, 59, 59, 999), r;
}
function Ja(e, t) {
  const r = R(e, t == null ? void 0 : t.in), n = r.getMonth();
  return r.setFullYear(r.getFullYear(), n + 1, 0), r.setHours(23, 59, 59, 999), r;
}
function ui(e, t) {
  const r = R(e, t == null ? void 0 : t.in);
  return +Xa(r, t) == +Ja(r, t);
}
function Za(e, t, r) {
  const [n, i, u] = st(
    r == null ? void 0 : r.in,
    e,
    e,
    t
  ), c = Qt(i, u), f = Math.abs(
    ai(i, u)
  );
  if (f < 1) return 0;
  i.getMonth() === 1 && i.getDate() > 27 && i.setDate(30), i.setMonth(i.getMonth() - c * f);
  let b = Qt(i, u) === -c;
  ui(n) && f === 1 && Qt(n, u) === 1 && (b = !1);
  const g = c * (f - +b);
  return g === 0 ? 0 : g;
}
function ci(e, t, r) {
  const n = Qa(e, t) / 1e3;
  return mr(r == null ? void 0 : r.roundingMethod)(n);
}
function to(e, t, r) {
  const [n, i] = st(
    r == null ? void 0 : r.in,
    e,
    t
  ), u = Qt(n, i), c = Math.abs(oi(n, i));
  n.setFullYear(1584), i.setFullYear(1584);
  const f = Qt(n, i) === -u, b = u * (c - +f);
  return b === 0 ? 0 : b;
}
function eo(e, t) {
  const [r, n] = st(e, t.start, t.end);
  return { start: r, end: n };
}
function li(e, t) {
  const { start: r, end: n } = eo(t == null ? void 0 : t.in, e);
  let i = +r > +n;
  const u = i ? +r : +n, c = i ? n : r;
  c.setHours(0, 0, 0, 0);
  let f = 1;
  const b = [];
  for (; +c <= u; )
    b.push(K(r, c)), c.setDate(c.getDate() + f), c.setHours(0, 0, 0, 0);
  return i ? b.reverse() : b;
}
function ro(e, t) {
  const r = R(e, t == null ? void 0 : t.in);
  return r.setDate(1), r.setHours(0, 0, 0, 0), r;
}
function fi(e, t) {
  const r = R(e, t == null ? void 0 : t.in);
  return r.setFullYear(r.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
const di = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, hi = (e, t, r) => {
  let n;
  const i = di[e];
  return typeof i == "string" ? n = i : t === 1 ? n = i.one : n = i.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
function Wt(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
const pi = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, yi = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, mi = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, gi = {
  date: Wt({
    formats: pi,
    defaultWidth: "full"
  }),
  time: Wt({
    formats: yi,
    defaultWidth: "full"
  }),
  dateTime: Wt({
    formats: mi,
    defaultWidth: "full"
  })
}, wi = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, vi = (e, t, r, n) => wi[e];
function ct(e) {
  return (t, r) => {
    const n = r != null && r.context ? String(r.context) : "standalone";
    let i;
    if (n === "formatting" && e.formattingValues) {
      const c = e.defaultFormattingWidth || e.defaultWidth, f = r != null && r.width ? String(r.width) : c;
      i = e.formattingValues[f] || e.formattingValues[c];
    } else {
      const c = e.defaultWidth, f = r != null && r.width ? String(r.width) : e.defaultWidth;
      i = e.values[f] || e.values[c];
    }
    const u = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[u];
  };
}
const bi = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Ei = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Si = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, ki = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Oi = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Ti = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, xi = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, Pi = {
  ordinalNumber: xi,
  era: ct({
    values: bi,
    defaultWidth: "wide"
  }),
  quarter: ct({
    values: Ei,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ct({
    values: Si,
    defaultWidth: "wide"
  }),
  day: ct({
    values: ki,
    defaultWidth: "wide"
  }),
  dayPeriod: ct({
    values: Oi,
    defaultWidth: "wide",
    formattingValues: Ti,
    defaultFormattingWidth: "wide"
  })
};
function lt(e) {
  return (t, r = {}) => {
    const n = r.width, i = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], u = t.match(i);
    if (!u)
      return null;
    const c = u[0], f = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], b = Array.isArray(f) ? Mi(f, (E) => E.test(c)) : (
      // [TODO] -- I challenge you to fix the type
      Ai(f, (E) => E.test(c))
    );
    let g;
    g = e.valueCallback ? e.valueCallback(b) : b, g = r.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      r.valueCallback(g)
    ) : g;
    const y = t.slice(c.length);
    return { value: g, rest: y };
  };
}
function Ai(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function Mi(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function no(e) {
  return (t, r = {}) => {
    const n = t.match(e.matchPattern);
    if (!n) return null;
    const i = n[0], u = t.match(e.parsePattern);
    if (!u) return null;
    let c = e.valueCallback ? e.valueCallback(u[0]) : u[0];
    c = r.valueCallback ? r.valueCallback(c) : c;
    const f = t.slice(i.length);
    return { value: c, rest: f };
  };
}
const Di = /^(\d+)(th|st|nd|rd)?/i, Ii = /\d+/i, Ni = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, ji = {
  any: [/^b/i, /^(a|c)/i]
}, _i = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Ri = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ci = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Fi = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Wi = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Li = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Ui = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Gi = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, qi = {
  ordinalNumber: no({
    matchPattern: Di,
    parsePattern: Ii,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: lt({
    matchPatterns: Ni,
    defaultMatchWidth: "wide",
    parsePatterns: ji,
    defaultParseWidth: "any"
  }),
  quarter: lt({
    matchPatterns: _i,
    defaultMatchWidth: "wide",
    parsePatterns: Ri,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: lt({
    matchPatterns: Ci,
    defaultMatchWidth: "wide",
    parsePatterns: Fi,
    defaultParseWidth: "any"
  }),
  day: lt({
    matchPatterns: Wi,
    defaultMatchWidth: "wide",
    parsePatterns: Li,
    defaultParseWidth: "any"
  }),
  dayPeriod: lt({
    matchPatterns: Ui,
    defaultMatchWidth: "any",
    parsePatterns: Gi,
    defaultParseWidth: "any"
  })
}, $i = {
  code: "en-US",
  formatDistance: hi,
  formatLong: gi,
  formatRelative: vi,
  localize: Pi,
  match: qi,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Yi(e, t) {
  const r = R(e, t == null ? void 0 : t.in);
  return Va(r, fi(r)) + 1;
}
function Bi(e, t) {
  const r = R(e, t == null ? void 0 : t.in), n = +oe(r) - +Zo(r);
  return Math.round(n / za) + 1;
}
function ao(e, t) {
  var y, E, p, d;
  const r = R(e, t == null ? void 0 : t.in), n = r.getFullYear(), i = se(), u = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((E = (y = t == null ? void 0 : t.locale) == null ? void 0 : y.options) == null ? void 0 : E.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((d = (p = i.locale) == null ? void 0 : p.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, c = K((t == null ? void 0 : t.in) || e, 0);
  c.setFullYear(n + 1, 0, u), c.setHours(0, 0, 0, 0);
  const f = Mt(c, t), b = K((t == null ? void 0 : t.in) || e, 0);
  b.setFullYear(n, 0, u), b.setHours(0, 0, 0, 0);
  const g = Mt(b, t);
  return +r >= +f ? n + 1 : +r >= +g ? n : n - 1;
}
function zi(e, t) {
  var f, b, g, y;
  const r = se(), n = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((b = (f = t == null ? void 0 : t.locale) == null ? void 0 : f.options) == null ? void 0 : b.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((y = (g = r.locale) == null ? void 0 : g.options) == null ? void 0 : y.firstWeekContainsDate) ?? 1, i = ao(e, t), u = K((t == null ? void 0 : t.in) || e, 0);
  return u.setFullYear(i, 0, n), u.setHours(0, 0, 0, 0), Mt(u, t);
}
function Hi(e, t) {
  const r = R(e, t == null ? void 0 : t.in), n = +Mt(r, t) - +zi(r, t);
  return Math.round(n / za) + 1;
}
function _(e, t) {
  const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return r + n;
}
const kt = {
  // Year
  y(e, t) {
    const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
    return _(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M(e, t) {
    const r = e.getMonth();
    return t === "M" ? String(r + 1) : _(r + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return _(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return _(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return _(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return _(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return _(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const r = t.length, n = e.getMilliseconds(), i = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return _(i, t.length);
  }
}, Ct = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Rr = {
  // Era
  G: function(e, t, r) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      const n = e.getFullYear(), i = n > 0 ? n : 1 - n;
      return r.ordinalNumber(i, { unit: "year" });
    }
    return kt.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, n) {
    const i = ao(e, n), u = i > 0 ? i : 1 - i;
    if (t === "YY") {
      const c = u % 100;
      return _(c, 2);
    }
    return t === "Yo" ? r.ordinalNumber(u, { unit: "year" }) : _(u, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const r = Ha(e);
    return _(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const r = e.getFullYear();
    return _(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(n);
      case "QQ":
        return _(n, 2);
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(n);
      case "qq":
        return _(n, 2);
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return kt.M(e, t);
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "L":
        return String(n + 1);
      case "LL":
        return _(n + 1, 2);
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, r, n) {
    const i = Hi(e, n);
    return t === "wo" ? r.ordinalNumber(i, { unit: "week" }) : _(i, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    const n = Bi(e);
    return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : _(n, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : kt.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    const n = Yi(e);
    return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : _(n, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    const n = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, n) {
    const i = e.getDay(), u = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(u);
      case "ee":
        return _(u, 2);
      case "eo":
        return r.ordinalNumber(u, { unit: "day" });
      case "eee":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, n) {
    const i = e.getDay(), u = (i - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(u);
      case "cc":
        return _(u, t.length);
      case "co":
        return r.ordinalNumber(u, { unit: "day" });
      case "ccc":
        return r.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    const n = e.getDay(), i = n === 0 ? 7 : n;
    switch (t) {
      case "i":
        return String(i);
      case "ii":
        return _(i, t.length);
      case "io":
        return r.ordinalNumber(i, { unit: "day" });
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    const i = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    const n = e.getHours();
    let i;
    switch (n === 12 ? i = Ct.noon : n === 0 ? i = Ct.midnight : i = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    const n = e.getHours();
    let i;
    switch (n >= 17 ? i = Ct.evening : n >= 12 ? i = Ct.afternoon : n >= 4 ? i = Ct.morning : i = Ct.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return kt.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : kt.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    const n = e.getHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : _(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : _(n, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : kt.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : kt.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return kt.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      case "X":
        return Fr(n);
      case "XXXX":
      case "XX":
        return Pt(n);
      case "XXXXX":
      case "XXX":
      default:
        return Pt(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return Fr(n);
      case "xxxx":
      case "xx":
        return Pt(n);
      case "xxxxx":
      case "xxx":
      default:
        return Pt(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Cr(n, ":");
      case "OOOO":
      default:
        return "GMT" + Pt(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Cr(n, ":");
      case "zzzz":
      default:
        return "GMT" + Pt(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r) {
    const n = Math.trunc(+e / 1e3);
    return _(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r) {
    return _(+e, t.length);
  }
};
function Cr(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), i = Math.trunc(n / 60), u = n % 60;
  return u === 0 ? r + String(i) : r + String(i) + t + _(u, 2);
}
function Fr(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + _(Math.abs(e) / 60, 2) : Pt(e, t);
}
function Pt(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), i = _(Math.trunc(n / 60), 2), u = _(n % 60, 2);
  return r + i + t + u;
}
const Wr = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, oo = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Vi = (e, t) => {
  const r = e.match(/(P+)(p+)?/) || [], n = r[1], i = r[2];
  if (!i)
    return Wr(e, t);
  let u;
  switch (n) {
    case "P":
      u = t.dateTime({ width: "short" });
      break;
    case "PP":
      u = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      u = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      u = t.dateTime({ width: "full" });
      break;
  }
  return u.replace("{{date}}", Wr(n, t)).replace("{{time}}", oo(i, t));
}, Ki = {
  p: oo,
  P: Vi
}, Qi = /^D+$/, Xi = /^Y+$/, Ji = ["D", "DD", "YY", "YYYY"];
function Zi(e) {
  return Qi.test(e);
}
function ts(e) {
  return Xi.test(e);
}
function es(e, t, r) {
  const n = rs(e, t, r);
  if (console.warn(n), Ji.includes(e)) throw new RangeError(n);
}
function rs(e, t, r) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const ns = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, as = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, os = /^'([^]*?)'?$/, is = /''/g, ss = /[a-zA-Z]/;
function us(e, t, r) {
  const n = se(), i = (r == null ? void 0 : r.locale) ?? n.locale ?? $i, u = r == null ? void 0 : r.firstWeekContainsDate, c = r == null ? void 0 : r.weekStartsOn, f = R(e, r == null ? void 0 : r.in);
  if (!Vt(f))
    throw new RangeError("Invalid time value");
  let b = t.match(as).map((y) => {
    const E = y[0];
    if (E === "p" || E === "P") {
      const p = Ki[E];
      return p(y, i.formatLong);
    }
    return y;
  }).join("").match(ns).map((y) => {
    if (y === "''")
      return { isToken: !1, value: "'" };
    const E = y[0];
    if (E === "'")
      return { isToken: !1, value: cs(y) };
    if (Rr[E])
      return { isToken: !0, value: y };
    if (E.match(ss))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + E + "`"
      );
    return { isToken: !1, value: y };
  });
  i.localize.preprocessor && (b = i.localize.preprocessor(f, b));
  const g = {
    firstWeekContainsDate: u,
    weekStartsOn: c,
    locale: i
  };
  return b.map((y) => {
    if (!y.isToken) return y.value;
    const E = y.value;
    (!(r != null && r.useAdditionalWeekYearTokens) && ts(E) || !(r != null && r.useAdditionalDayOfYearTokens) && Zi(E)) && es(E, t, String(e));
    const p = Rr[E[0]];
    return p(f, E, i.localize, g);
  }).join("");
}
function cs(e) {
  const t = e.match(os);
  return t ? t[1].replace(is, "'") : e;
}
function ls(e, t) {
  const r = R(e, t == null ? void 0 : t.in);
  if (isNaN(+r))
    throw new RangeError("Invalid time value");
  let n = "", i = "";
  const u = "-", c = ":";
  {
    const f = _(r.getDate(), 2), b = _(r.getMonth() + 1, 2);
    n = `${_(r.getFullYear(), 4)}${u}${b}${u}${f}`;
  }
  {
    const f = r.getTimezoneOffset();
    if (f !== 0) {
      const d = Math.abs(f), x = _(Math.trunc(d / 60), 2), k = _(d % 60, 2);
      i = `${f < 0 ? "+" : "-"}${x}:${k}`;
    } else
      i = "Z";
    const b = _(r.getHours(), 2), g = _(r.getMinutes(), 2), y = _(r.getSeconds(), 2), E = n === "" ? "" : "T", p = [b, g, y].join(c);
    n = `${n}${E}${p}${i}`;
  }
  return n;
}
function Lr(e, t) {
  return R(e, t == null ? void 0 : t.in).getDay();
}
function fs(e, t) {
  const r = R(e, t == null ? void 0 : t.in), n = r.getFullYear(), i = r.getMonth(), u = K(r, 0);
  return u.setFullYear(n, i + 1, 0), u.setHours(0, 0, 0, 0), u.getDate();
}
function ds(e, t) {
  return R(e, t == null ? void 0 : t.in).getMonth();
}
function hs(e, t) {
  const r = R(e, t == null ? void 0 : t.in), n = r.getMonth();
  return r.setFullYear(r.getFullYear(), n + 1, 0), r.setHours(0, 0, 0, 0), R(r, t == null ? void 0 : t.in);
}
function ps(e, t) {
  const { start: r, end: n } = eo(t == null ? void 0 : t.in, e), i = {}, u = to(n, r);
  u && (i.years = u);
  const c = Yt(r, { years: i.years }), f = Za(n, c);
  f && (i.months = f);
  const b = Yt(c, { months: i.months }), g = Ka(n, b);
  g && (i.days = g);
  const y = Yt(b, { days: i.days }), E = ii(n, y);
  E && (i.hours = E);
  const p = Yt(y, { hours: i.hours }), d = si(n, p);
  d && (i.minutes = d);
  const x = Yt(p, { minutes: i.minutes }), k = ci(n, x);
  return k && (i.seconds = k), i;
}
function ys(e, t, r) {
  const n = new Date(e, t, r);
  return n.getFullYear() === e && n.getMonth() === t && n.getDate() === r;
}
function Ur(e, t, r) {
  const [n, i] = st(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return +Mt(n, r) == +Mt(i, r);
}
function ms(e, t, r) {
  const [n, i] = st(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return n.getFullYear() === i.getFullYear() && n.getMonth() === i.getMonth();
}
function gs(e, t, r) {
  const [n, i] = st(
    r == null ? void 0 : r.in,
    e,
    t
  );
  return n.getFullYear() === i.getFullYear();
}
function ws(e, t) {
  const r = () => K(t == null ? void 0 : t.in, NaN), i = Ss(e);
  let u;
  if (i.date) {
    const g = ks(i.date, 2);
    u = Os(g.restDateString, g.year);
  }
  if (!u || isNaN(+u)) return r();
  const c = +u;
  let f = 0, b;
  if (i.time && (f = Ts(i.time), isNaN(f)))
    return r();
  if (i.timezone) {
    if (b = xs(i.timezone), isNaN(b)) return r();
  } else {
    const g = new Date(c + f), y = R(0, t == null ? void 0 : t.in);
    return y.setFullYear(
      g.getUTCFullYear(),
      g.getUTCMonth(),
      g.getUTCDate()
    ), y.setHours(
      g.getUTCHours(),
      g.getUTCMinutes(),
      g.getUTCSeconds(),
      g.getUTCMilliseconds()
    ), y;
  }
  return R(c + f + b, t == null ? void 0 : t.in);
}
const re = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, vs = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, bs = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, Es = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Ss(e) {
  const t = {}, r = e.split(re.dateTimeDelimiter);
  let n;
  if (r.length > 2)
    return t;
  if (/:/.test(r[0]) ? n = r[0] : (t.date = r[0], n = r[1], re.timeZoneDelimiter.test(t.date) && (t.date = e.split(re.timeZoneDelimiter)[0], n = e.substr(
    t.date.length,
    e.length
  ))), n) {
    const i = re.timezone.exec(n);
    i ? (t.time = n.replace(i[1], ""), t.timezone = i[1]) : t.time = n;
  }
  return t;
}
function ks(e, t) {
  const r = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), n = e.match(r);
  if (!n) return { year: NaN, restDateString: "" };
  const i = n[1] ? parseInt(n[1]) : null, u = n[2] ? parseInt(n[2]) : null;
  return {
    year: u === null ? i : u * 100,
    restDateString: e.slice((n[1] || n[2]).length)
  };
}
function Os(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  const r = e.match(vs);
  if (!r) return /* @__PURE__ */ new Date(NaN);
  const n = !!r[4], i = Bt(r[1]), u = Bt(r[2]) - 1, c = Bt(r[3]), f = Bt(r[4]), b = Bt(r[5]) - 1;
  if (n)
    return Is(t, f, b) ? Ps(t, f, b) : /* @__PURE__ */ new Date(NaN);
  {
    const g = /* @__PURE__ */ new Date(0);
    return !Ms(t, u, c) || !Ds(t, i) ? /* @__PURE__ */ new Date(NaN) : (g.setUTCFullYear(t, u, Math.max(i, c)), g);
  }
}
function Bt(e) {
  return e ? parseInt(e) : 1;
}
function Ts(e) {
  const t = e.match(bs);
  if (!t) return NaN;
  const r = Ee(t[1]), n = Ee(t[2]), i = Ee(t[3]);
  return Ns(r, n, i) ? r * pr + n * ie + i * 1e3 : NaN;
}
function Ee(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function xs(e) {
  if (e === "Z") return 0;
  const t = e.match(Es);
  if (!t) return 0;
  const r = t[1] === "+" ? -1 : 1, n = parseInt(t[2]), i = t[3] && parseInt(t[3]) || 0;
  return js(n, i) ? r * (n * pr + i * ie) : NaN;
}
function Ps(e, t, r) {
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  const i = n.getUTCDay() || 7, u = (t - 1) * 7 + r + 1 - i;
  return n.setUTCDate(n.getUTCDate() + u), n;
}
const As = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function io(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Ms(e, t, r) {
  return t >= 0 && t <= 11 && r >= 1 && r <= (As[t] || (io(e) ? 29 : 28));
}
function Ds(e, t) {
  return t >= 1 && t <= (io(e) ? 366 : 365);
}
function Is(e, t, r) {
  return t >= 1 && t <= 53 && r >= 0 && r <= 6;
}
function Ns(e, t, r) {
  return e === 24 ? t === 0 && r === 0 : r >= 0 && r < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function js(e, t) {
  return t >= 0 && t <= 59;
}
function _s(e, t, r) {
  const n = R(e, r == null ? void 0 : r.in), i = n.getFullYear(), u = n.getDate(), c = K(e, 0);
  c.setFullYear(i, t, 15), c.setHours(0, 0, 0, 0);
  const f = fs(c);
  return n.setMonth(t, Math.min(u, f)), n;
}
function Rs(e, t, r) {
  const n = R(e, r == null ? void 0 : r.in);
  return isNaN(+n) ? K(e, NaN) : (n.setFullYear(t), n);
}
function zt(e, t) {
  if (e.one !== void 0 && t === 1)
    return e.one;
  const r = t % 10, n = t % 100;
  return r === 1 && n !== 11 ? e.singularNominative.replace("{{count}}", String(t)) : r >= 2 && r <= 4 && (n < 10 || n > 20) ? e.singularGenitive.replace("{{count}}", String(t)) : e.pluralGenitive.replace("{{count}}", String(t));
}
function Q(e) {
  return (t, r) => r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? e.future ? zt(e.future, t) : "через " + zt(e.regular, t) : e.past ? zt(e.past, t) : zt(e.regular, t) + " назад" : zt(e.regular, t);
}
const Cs = {
  lessThanXSeconds: Q({
    regular: {
      one: "меньше секунды",
      singularNominative: "меньше {{count}} секунды",
      singularGenitive: "меньше {{count}} секунд",
      pluralGenitive: "меньше {{count}} секунд"
    },
    future: {
      one: "меньше, чем через секунду",
      singularNominative: "меньше, чем через {{count}} секунду",
      singularGenitive: "меньше, чем через {{count}} секунды",
      pluralGenitive: "меньше, чем через {{count}} секунд"
    }
  }),
  xSeconds: Q({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду назад",
      singularGenitive: "{{count}} секунды назад",
      pluralGenitive: "{{count}} секунд назад"
    },
    future: {
      singularNominative: "через {{count}} секунду",
      singularGenitive: "через {{count}} секунды",
      pluralGenitive: "через {{count}} секунд"
    }
  }),
  halfAMinute: (e, t) => t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "через полминуты" : "полминуты назад" : "полминуты",
  lessThanXMinutes: Q({
    regular: {
      one: "меньше минуты",
      singularNominative: "меньше {{count}} минуты",
      singularGenitive: "меньше {{count}} минут",
      pluralGenitive: "меньше {{count}} минут"
    },
    future: {
      one: "меньше, чем через минуту",
      singularNominative: "меньше, чем через {{count}} минуту",
      singularGenitive: "меньше, чем через {{count}} минуты",
      pluralGenitive: "меньше, чем через {{count}} минут"
    }
  }),
  xMinutes: Q({
    regular: {
      singularNominative: "{{count}} минута",
      singularGenitive: "{{count}} минуты",
      pluralGenitive: "{{count}} минут"
    },
    past: {
      singularNominative: "{{count}} минуту назад",
      singularGenitive: "{{count}} минуты назад",
      pluralGenitive: "{{count}} минут назад"
    },
    future: {
      singularNominative: "через {{count}} минуту",
      singularGenitive: "через {{count}} минуты",
      pluralGenitive: "через {{count}} минут"
    }
  }),
  aboutXHours: Q({
    regular: {
      singularNominative: "около {{count}} часа",
      singularGenitive: "около {{count}} часов",
      pluralGenitive: "около {{count}} часов"
    },
    future: {
      singularNominative: "приблизительно через {{count}} час",
      singularGenitive: "приблизительно через {{count}} часа",
      pluralGenitive: "приблизительно через {{count}} часов"
    }
  }),
  xHours: Q({
    regular: {
      singularNominative: "{{count}} час",
      singularGenitive: "{{count}} часа",
      pluralGenitive: "{{count}} часов"
    }
  }),
  xDays: Q({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} дня",
      pluralGenitive: "{{count}} дней"
    }
  }),
  aboutXWeeks: Q({
    regular: {
      singularNominative: "около {{count}} недели",
      singularGenitive: "около {{count}} недель",
      pluralGenitive: "около {{count}} недель"
    },
    future: {
      singularNominative: "приблизительно через {{count}} неделю",
      singularGenitive: "приблизительно через {{count}} недели",
      pluralGenitive: "приблизительно через {{count}} недель"
    }
  }),
  xWeeks: Q({
    regular: {
      singularNominative: "{{count}} неделя",
      singularGenitive: "{{count}} недели",
      pluralGenitive: "{{count}} недель"
    }
  }),
  aboutXMonths: Q({
    regular: {
      singularNominative: "около {{count}} месяца",
      singularGenitive: "около {{count}} месяцев",
      pluralGenitive: "около {{count}} месяцев"
    },
    future: {
      singularNominative: "приблизительно через {{count}} месяц",
      singularGenitive: "приблизительно через {{count}} месяца",
      pluralGenitive: "приблизительно через {{count}} месяцев"
    }
  }),
  xMonths: Q({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяца",
      pluralGenitive: "{{count}} месяцев"
    }
  }),
  aboutXYears: Q({
    regular: {
      singularNominative: "около {{count}} года",
      singularGenitive: "около {{count}} лет",
      pluralGenitive: "около {{count}} лет"
    },
    future: {
      singularNominative: "приблизительно через {{count}} год",
      singularGenitive: "приблизительно через {{count}} года",
      pluralGenitive: "приблизительно через {{count}} лет"
    }
  }),
  xYears: Q({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} года",
      pluralGenitive: "{{count}} лет"
    }
  }),
  overXYears: Q({
    regular: {
      singularNominative: "больше {{count}} года",
      singularGenitive: "больше {{count}} лет",
      pluralGenitive: "больше {{count}} лет"
    },
    future: {
      singularNominative: "больше, чем через {{count}} год",
      singularGenitive: "больше, чем через {{count}} года",
      pluralGenitive: "больше, чем через {{count}} лет"
    }
  }),
  almostXYears: Q({
    regular: {
      singularNominative: "почти {{count}} год",
      singularGenitive: "почти {{count}} года",
      pluralGenitive: "почти {{count}} лет"
    },
    future: {
      singularNominative: "почти через {{count}} год",
      singularGenitive: "почти через {{count}} года",
      pluralGenitive: "почти через {{count}} лет"
    }
  })
}, Fs = (e, t, r) => Cs[e](t, r), Ws = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, Ls = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, Us = {
  any: "{{date}}, {{time}}"
}, Gs = {
  date: Wt({
    formats: Ws,
    defaultWidth: "full"
  }),
  time: Wt({
    formats: Ls,
    defaultWidth: "full"
  }),
  dateTime: Wt({
    formats: Us,
    defaultWidth: "any"
  })
}, gr = [
  "воскресенье",
  "понедельник",
  "вторник",
  "среду",
  "четверг",
  "пятницу",
  "субботу"
];
function qs(e) {
  const t = gr[e];
  switch (e) {
    case 0:
      return "'в прошлое " + t + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в прошлый " + t + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в прошлую " + t + " в' p";
  }
}
function Gr(e) {
  const t = gr[e];
  return e === 2 ? "'во " + t + " в' p" : "'в " + t + " в' p";
}
function $s(e) {
  const t = gr[e];
  switch (e) {
    case 0:
      return "'в следующее " + t + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в следующий " + t + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в следующую " + t + " в' p";
  }
}
const Ys = {
  lastWeek: (e, t, r) => {
    const n = e.getDay();
    return Ur(e, t, r) ? Gr(n) : qs(n);
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: (e, t, r) => {
    const n = e.getDay();
    return Ur(e, t, r) ? Gr(n) : $s(n);
  },
  other: "P"
}, Bs = (e, t, r, n) => {
  const i = Ys[e];
  return typeof i == "function" ? i(t, r, n) : i;
}, zs = {
  narrow: ["до н.э.", "н.э."],
  abbreviated: ["до н. э.", "н. э."],
  wide: ["до нашей эры", "нашей эры"]
}, Hs = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"]
}, Vs = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв.",
    "фев.",
    "март",
    "апр.",
    "май",
    "июнь",
    "июль",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек."
  ],
  wide: [
    "январь",
    "февраль",
    "март",
    "апрель",
    "май",
    "июнь",
    "июль",
    "август",
    "сентябрь",
    "октябрь",
    "ноябрь",
    "декабрь"
  ]
}, Ks = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв.",
    "фев.",
    "мар.",
    "апр.",
    "мая",
    "июн.",
    "июл.",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек."
  ],
  wide: [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря"
  ]
}, Qs = {
  narrow: ["В", "П", "В", "С", "Ч", "П", "С"],
  short: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["вск", "пнд", "втр", "срд", "чтв", "птн", "суб"],
  wide: [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота"
  ]
}, Xs = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утро",
    afternoon: "день",
    evening: "вечер",
    night: "ночь"
  }
}, Js = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утра",
    afternoon: "дня",
    evening: "вечера",
    night: "ночи"
  }
}, Zs = (e, t) => {
  const r = Number(e), n = t == null ? void 0 : t.unit;
  let i;
  return n === "date" ? i = "-е" : n === "week" || n === "minute" || n === "second" ? i = "-я" : i = "-й", r + i;
}, tu = {
  ordinalNumber: Zs,
  era: ct({
    values: zs,
    defaultWidth: "wide"
  }),
  quarter: ct({
    values: Hs,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ct({
    values: Vs,
    defaultWidth: "wide",
    formattingValues: Ks,
    defaultFormattingWidth: "wide"
  }),
  day: ct({
    values: Qs,
    defaultWidth: "wide"
  }),
  dayPeriod: ct({
    values: Xs,
    defaultWidth: "any",
    formattingValues: Js,
    defaultFormattingWidth: "wide"
  })
}, eu = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i, ru = /\d+/i, nu = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i
}, au = {
  any: [/^д/i, /^н/i]
}, ou = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i
}, iu = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, su = {
  narrow: /^[яфмаисонд]/i,
  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
}, uu = {
  narrow: [
    /^я/i,
    /^ф/i,
    /^м/i,
    /^а/i,
    /^м/i,
    /^и/i,
    /^и/i,
    /^а/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^я/i
  ],
  any: [
    /^я/i,
    /^ф/i,
    /^мар/i,
    /^ап/i,
    /^ма[йя]/i,
    /^июн/i,
    /^июл/i,
    /^ав/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^д/i
  ]
}, cu = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
}, lu = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, fu = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
}, du = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, hu = {
  ordinalNumber: no({
    matchPattern: eu,
    parsePattern: ru,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: lt({
    matchPatterns: nu,
    defaultMatchWidth: "wide",
    parsePatterns: au,
    defaultParseWidth: "any"
  }),
  quarter: lt({
    matchPatterns: ou,
    defaultMatchWidth: "wide",
    parsePatterns: iu,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: lt({
    matchPatterns: su,
    defaultMatchWidth: "wide",
    parsePatterns: uu,
    defaultParseWidth: "any"
  }),
  day: lt({
    matchPatterns: cu,
    defaultMatchWidth: "wide",
    parsePatterns: lu,
    defaultParseWidth: "any"
  }),
  dayPeriod: lt({
    matchPatterns: fu,
    defaultMatchWidth: "wide",
    parsePatterns: du,
    defaultParseWidth: "any"
  })
}, pu = {
  code: "ru",
  formatDistance: Fs,
  formatLong: Gs,
  formatRelative: Bs,
  localize: tu,
  match: hu,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, qr = 7, yu = /(\d{1,2})[./-](\d{1,2})[./-](\d{4})/, mu = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|([+-]\d{2}:\d{2})))?$/, Yc = (e) => {
  let t = ro(e), r = hs(e);
  const n = Lr(Kt(t, -1)), i = (qr - Lr(r)) % qr;
  return t = Kt(t, -n), r = Kt(r, i), li({ start: t, end: r }).map((u) => u.getTime());
}, Bc = (e) => Xt(e).getTime(), zc = (e) => Xa(e).getTime(), Hc = (e) => ro(e).getTime(), Vc = (e) => Ja(e).getTime(), Kc = (e) => ls(e), Qc = (e, t) => Kt(e, t), Xc = (e, t) => yr(e, t), Jc = (e, t) => ei(e, t), Zc = (e, t) => us(e, t, {
  locale: pu,
  firstWeekContainsDate: 1,
  weekStartsOn: 1
}), tl = (e) => ds(e), el = (e, t) => ri(e, t), rl = (e, t) => ms(e, t), nl = (e, t) => gs(e, t), al = (e, t) => _s(e, t), ol = (e, t) => Rs(e, t), il = (e) => {
  if (e instanceof Date)
    return Vt(e) ? e : null;
  if (typeof e == "number") {
    const r = new Date(e);
    return Vt(r) ? r : null;
  }
  const t = e.match(yu);
  if (t) {
    const r = Number(t[1]), n = Number(t[2]), i = Number(t[3]);
    if (ys(i, n - 1, r))
      return new Date(i, n - 1, r);
    const u = e.replaceAll(".", "/"), c = new Date(u);
    return Vt(c) ? c : null;
  }
  if (mu.test(e)) {
    const r = ws(e);
    return Vt(r) ? r : null;
  }
  return null;
}, sl = (e, t, r = "days") => Math.abs({
  days: Ka,
  months: Za,
  years: to
}[r](t, e)), ul = (e) => {
  const t = /* @__PURE__ */ new Date(0), r = ti(t, e), n = ps({ start: t, end: r });
  return {
    days: n.days || 0,
    hours: n.hours || 0,
    minutes: n.minutes || 0
  };
}, cl = (e) => {
  const t = document.querySelector("body");
  t && (t.style.overflow = e);
}, wr = (e, {
  async: t = !0,
  type: r = "text/javascript",
  onload: n = null
} = {}) => {
  const i = new URL(e, location.origin).href;
  if (document.querySelector(`script[src="${i}"]`))
    return;
  const u = Object.assign(document.createElement("script"), {
    type: r,
    async: t,
    src: i,
    onload: n
  });
  document.head.insertBefore(u, document.head.querySelector("script") || null);
}, dr = " ";
function ll(e, t = "RUB") {
  const r = {
    style: "decimal",
    maximumFractionDigits: 0
  };
  return t && (r.style = "currency", r.currency = t), new Intl.NumberFormat("ru-RU", r).format(e).replaceAll(/\s/g, dr);
}
function fl(e) {
  const r = e.replaceAll(/\D/g, "").match(/^[78]?(\d{3})(\d{3})(\d{2})(\d{2})$/);
  return r ? `+7${dr}(${r[1]})${dr}${r[2]}-${r[3]}-${r[4]}` : e;
}
function dl(e, t, r = !0) {
  const n = t % 100 > 4 && t % 100 < 20 ? 2 : [2, 0, 1, 1, 1, 2][t % 10 < 5 ? Math.abs(t) % 10 : 5];
  return r ? `${t} ${e[n]}` : e[n];
}
const hl = "Enter", pl = "Escape", yl = " ", ml = "Tab", gl = (e, t) => {
  let r = null;
  return (...n) => {
    r && clearTimeout(r), r = setTimeout(() => e(...n), t);
  };
}, wl = (e, t) => {
  let r = !1;
  return (...n) => {
    r || (e(...n), r = !0, setTimeout(() => {
      r = !1;
    }, t));
  };
}, gu = (e) => {
  setTimeout(e, 0);
}, vl = (e) => e ? e.some((t) => t.isComment || Array.isArray(t.children) && t.children.length === 0 ? !1 : t.tag !== void 0 || t.text && t.text.replaceAll(/\s+/g, "").trim().length > 0) : !1;
class wu extends Jt {
  constructor() {
    super(...arguments);
    N(this, "id");
    N(this, "bannerTypeId");
  }
  init(r) {
    this.isStartedInit || (this.id = r.id, this.bannerTypeId = r.bannerTypeId, this.baseInit(r.timeoutMS));
  }
  install() {
    if (!this.id || !this.bannerTypeId)
      throw new Lt("AdriverAnalyticsProvider requires a id and bannerTypeId parameters", {
        serviceName: V.ADRIVER
      });
    window.adrCounterStorage || (window.adrCounterStorage = []), wr(jc);
  }
  isInstalled() {
    return typeof window.AdriverCounterJS == "function";
  }
  track(r, n) {
    this.enqueueOrExecute(
      () => window.adrCounterStorage.push(
        () => new window.AdriverCounterJS(
          { sid: this.id, bt: this.bannerTypeId, ...(n == null ? void 0 : n.segment) && { sz: n.segment } },
          r
        )
      )
    );
  }
}
var vu = Object.defineProperty, bu = (e, t, r) => t in e ? vu(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, yt = (e, t, r) => bu(e, typeof t != "symbol" ? t + "" : t, r), $r = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function so(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Eu(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Yr = { exports: {} };
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
var Br;
function Su() {
  return Br || (Br = 1, function(e, t) {
    (function(r) {
      var n;
      if (e.exports = r(), n = !0, !n) {
        var i = window.Cookies, u = window.Cookies = r();
        u.noConflict = function() {
          return window.Cookies = i, u;
        };
      }
    })(function() {
      function r() {
        for (var u = 0, c = {}; u < arguments.length; u++) {
          var f = arguments[u];
          for (var b in f)
            c[b] = f[b];
        }
        return c;
      }
      function n(u) {
        return u.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
      }
      function i(u) {
        function c() {
        }
        function f(g, y, E) {
          if (!(typeof document > "u")) {
            E = r({
              path: "/"
            }, c.defaults, E), typeof E.expires == "number" && (E.expires = new Date(/* @__PURE__ */ new Date() * 1 + E.expires * 864e5)), E.expires = E.expires ? E.expires.toUTCString() : "";
            try {
              var p = JSON.stringify(y);
              /^[\{\[]/.test(p) && (y = p);
            } catch {
            }
            y = u.write ? u.write(y, g) : encodeURIComponent(String(y)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), g = encodeURIComponent(String(g)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var d = "";
            for (var x in E)
              E[x] && (d += "; " + x, E[x] !== !0 && (d += "=" + E[x].split(";")[0]));
            return document.cookie = g + "=" + y + d;
          }
        }
        function b(g, y) {
          if (!(typeof document > "u")) {
            for (var E = {}, p = document.cookie ? document.cookie.split("; ") : [], d = 0; d < p.length; d++) {
              var x = p[d].split("="), k = x.slice(1).join("=");
              !y && k.charAt(0) === '"' && (k = k.slice(1, -1));
              try {
                var T = n(x[0]);
                if (k = (u.read || u)(k, T) || n(k), y)
                  try {
                    k = JSON.parse(k);
                  } catch {
                  }
                if (E[T] = k, g === T)
                  break;
              } catch {
              }
            }
            return g ? E[g] : E;
          }
        }
        return c.set = f, c.get = function(g) {
          return b(
            g,
            !1
            /* read as raw */
          );
        }, c.getJSON = function(g) {
          return b(
            g,
            !0
            /* read as json */
          );
        }, c.remove = function(g, y) {
          f(g, "", r(y, {
            expires: -1
          }));
        }, c.defaults = {}, c.withConverter = i, c;
      }
      return i(function() {
      });
    });
  }(Yr)), Yr.exports;
}
var ku = Su();
const Se = /* @__PURE__ */ so(ku);
class Ft {
  constructor(t = {}) {
    yt(this, "_clientUuid"), yt(this, "clientUuid"), yt(this, "api"), yt(this, "wasSend");
    const { api: r, clientUuid: n } = t;
    if (this._clientUuid = n, this.clientUuid = this.getOurClientUuid(), this.api = r, this.initWasSendAnalyticsCookies(), this.clientUuid)
      this.getAnalyticsData();
    else
      throw new Error("the cookie — clientUuid is not found");
  }
  initWasSendAnalyticsCookies() {
    this.wasSend = {
      yaIdCookiesName: "_Tr_ym_uid_w_send",
      gaIdCookiesName: "_Tr_ga_w_send"
    };
  }
  getAnalyticsData() {
    let t = Ft.getMetrikaId(), r = Ft.getGAId(), n = 120, i = 0;
    if (this.confirmCookies(t, r), !this.wasSend.yaId || !this.wasSend.gaId) {
      const u = setInterval(() => {
        if (t || (t = Ft.getMetrikaId()), r || (r = Ft.getGAId()), this.confirmCookies(t, r), this.wasSend.yaId && this.wasSend.gaId)
          clearInterval(u);
        else if (i > n)
          throw clearInterval(u), new Error(`no_cookies_found; navigator.cookieEnabled: ${navigator && navigator.cookieEnabled}`);
        i++;
      }, 1e3);
    }
  }
  confirmCookies(t, r) {
    t && !this.wasSend.yaId && r && !this.wasSend.gaId ? (this.setAnalytics({ yaId: t, gaId: r }), this.wasSend.yaId = t, this.wasSend.gaId = r) : t && !this.wasSend.yaId ? (this.setAnalytics({ yaId: t }), this.wasSend.yaId = t) : r && !this.wasSend.gaId && (this.setAnalytics({ gaId: r }), this.wasSend.gaId = r);
  }
  setAnalytics({ yaId: t, gaId: r }) {
    const n = this.clientUuid;
    if (this.api && this.api.setAnalytics)
      this.api.setAnalytics({ yaId: t, gaId: r, clientUuid: n });
    else
      throw new Error("no correct api provided");
  }
  getOurClientUuid() {
    return this._clientUuid || Se.get("clientUuid");
  }
  static getMetrikaId() {
    return Se.get("_ym_uid");
  }
  static getGAId() {
    return Se.get("_ga");
  }
  getClientUuid() {
    return this.clientUuid;
  }
}
var zr, Hr;
function Ut() {
  return Hr || (Hr = 1, zr = TypeError), zr;
}
const Ou = {}, Tu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ou
}, Symbol.toStringTag, { value: "Module" })), xu = /* @__PURE__ */ Eu(Tu);
var ke, Vr;
function ue() {
  if (Vr) return ke;
  Vr = 1;
  var e = typeof Map == "function" && Map.prototype, t = Object.getOwnPropertyDescriptor && e ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, r = e && t && typeof t.get == "function" ? t.get : null, n = e && Map.prototype.forEach, i = typeof Set == "function" && Set.prototype, u = Object.getOwnPropertyDescriptor && i ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, c = i && u && typeof u.get == "function" ? u.get : null, f = i && Set.prototype.forEach, b = typeof WeakMap == "function" && WeakMap.prototype, g = b ? WeakMap.prototype.has : null, y = typeof WeakSet == "function" && WeakSet.prototype, E = y ? WeakSet.prototype.has : null, p = typeof WeakRef == "function" && WeakRef.prototype, d = p ? WeakRef.prototype.deref : null, x = Boolean.prototype.valueOf, k = Object.prototype.toString, T = Function.prototype.toString, a = String.prototype.match, s = String.prototype.slice, o = String.prototype.replace, l = String.prototype.toUpperCase, h = String.prototype.toLowerCase, w = RegExp.prototype.test, m = Array.prototype.concat, O = Array.prototype.join, P = Array.prototype.slice, D = Math.floor, A = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, M = Object.getOwnPropertySymbols, W = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, $ = typeof Symbol == "function" && typeof Symbol.iterator == "object", X = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $ || !0) ? Symbol.toStringTag : null, ft = Object.prototype.propertyIsEnumerable, dt = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(v) {
    return v.__proto__;
  } : null);
  function j(v, S) {
    if (v === 1 / 0 || v === -1 / 0 || v !== v || v && v > -1e3 && v < 1e3 || w.call(/e/, S))
      return S;
    var C = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof v == "number") {
      var U = v < 0 ? -D(-v) : D(v);
      if (U !== v) {
        var q = String(U), I = s.call(S, q.length + 1);
        return o.call(q, C, "$&_") + "." + o.call(o.call(I, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return o.call(S, C, "$&_");
  }
  var J = xu, ht = J.custom, Ot = ot(ht) ? ht : null, mt = {
    __proto__: null,
    double: '"',
    single: "'"
  }, gt = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  ke = function v(S, C, U, q) {
    var I = C || {};
    if (Z(I, "quoteStyle") && !Z(mt, I.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (Z(I, "maxStringLength") && (typeof I.maxStringLength == "number" ? I.maxStringLength < 0 && I.maxStringLength !== 1 / 0 : I.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var Et = Z(I, "customInspect") ? I.customInspect : !0;
    if (typeof Et != "boolean" && Et !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (Z(I, "indent") && I.indent !== null && I.indent !== "	" && !(parseInt(I.indent, 10) === I.indent && I.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (Z(I, "numericSeparator") && typeof I.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var xt = I.numericSeparator;
    if (typeof S > "u")
      return "undefined";
    if (S === null)
      return "null";
    if (typeof S == "boolean")
      return S ? "true" : "false";
    if (typeof S == "string")
      return Sr(S, I);
    if (typeof S == "number") {
      if (S === 0)
        return 1 / 0 / S > 0 ? "0" : "-0";
      var et = String(S);
      return xt ? j(S, et) : et;
    }
    if (typeof S == "bigint") {
      var St = String(S) + "n";
      return xt ? j(S, St) : St;
    }
    var de = typeof I.depth > "u" ? 5 : I.depth;
    if (typeof U > "u" && (U = 0), U >= de && de > 0 && typeof S == "object")
      return vt(S) ? "[Array]" : "[Object]";
    var _t = Do(I, U);
    if (typeof q > "u")
      q = [];
    else if (it(q, S) >= 0)
      return "[Circular]";
    function ut(Rt, ee, No) {
      if (ee && (q = P.call(q), q.push(ee)), No) {
        var Ir = {
          depth: I.depth
        };
        return Z(I, "quoteStyle") && (Ir.quoteStyle = I.quoteStyle), v(Rt, Ir, U + 1, q);
      }
      return v(Rt, I, U + 1, q);
    }
    if (typeof S == "function" && !L(S)) {
      var Or = Tt(S), Tr = Zt(S, ut);
      return "[Function" + (Or ? ": " + Or : " (anonymous)") + "]" + (Tr.length > 0 ? " { " + O.call(Tr, ", ") + " }" : "");
    }
    if (ot(S)) {
      var xr = $ ? o.call(String(S), /^(Symbol\(.*\))_[^)]*$/, "$1") : W.call(S);
      return typeof S == "object" && !$ ? Gt(xr) : xr;
    }
    if (Po(S)) {
      for (var qt = "<" + h.call(String(S.nodeName)), he = S.attributes || [], te = 0; te < he.length; te++)
        qt += " " + he[te].name + "=" + wt(pt(he[te].value), "double", I);
      return qt += ">", S.childNodes && S.childNodes.length && (qt += "..."), qt += "</" + h.call(String(S.nodeName)) + ">", qt;
    }
    if (vt(S)) {
      if (S.length === 0)
        return "[]";
      var pe = Zt(S, ut);
      return _t && !Mo(pe) ? "[" + fe(pe, _t) + "]" : "[ " + O.call(pe, ", ") + " ]";
    }
    if (G(S)) {
      var ye = Zt(S, ut);
      return !("cause" in Error.prototype) && "cause" in S && !ft.call(S, "cause") ? "{ [" + String(S) + "] " + O.call(m.call("[cause]: " + ut(S.cause), ye), ", ") + " }" : ye.length === 0 ? "[" + String(S) + "]" : "{ [" + String(S) + "] " + O.call(ye, ", ") + " }";
    }
    if (typeof S == "object" && Et) {
      if (Ot && typeof S[Ot] == "function" && J)
        return J(S, {
          depth: de - U
        });
      if (Et !== "symbol" && typeof S.inspect == "function")
        return S.inspect();
    }
    if (It(S)) {
      var Pr = [];
      return n && n.call(S, function(Rt, ee) {
        Pr.push(ut(ee, S, !0) + " => " + ut(Rt, S));
      }), kr("Map", r.call(S), Pr, _t);
    }
    if (To(S)) {
      var Ar = [];
      return f && f.call(S, function(Rt) {
        Ar.push(ut(Rt, S));
      }), kr("Set", c.call(S), Ar, _t);
    }
    if (Nt(S))
      return le("WeakMap");
    if (xo(S))
      return le("WeakSet");
    if (jt(S))
      return le("WeakRef");
    if (Y(S))
      return Gt(ut(Number(S)));
    if (B(S))
      return Gt(ut(A.call(S)));
    if (H(S))
      return Gt(x.call(S));
    if (F(S))
      return Gt(ut(String(S)));
    if (typeof window < "u" && S === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && S === globalThis || typeof $r < "u" && S === $r)
      return "{ [object globalThis] }";
    if (!bt(S) && !L(S)) {
      var me = Zt(S, ut), Mr = dt ? dt(S) === Object.prototype : S instanceof Object || S.constructor === Object, ge = S instanceof Object ? "" : "null prototype", Dr = !Mr && X && Object(S) === S && X in S ? s.call(tt(S), 8, -1) : ge ? "Object" : "", Io = Mr || typeof S.constructor != "function" ? "" : S.constructor.name ? S.constructor.name + " " : "", we = Io + (Dr || ge ? "[" + O.call(m.call([], Dr || [], ge || []), ": ") + "] " : "");
      return me.length === 0 ? we + "{}" : _t ? we + "{" + fe(me, _t) + "}" : we + "{ " + O.call(me, ", ") + " }";
    }
    return String(S);
  };
  function wt(v, S, C) {
    var U = C.quoteStyle || S, q = mt[U];
    return q + v + q;
  }
  function pt(v) {
    return o.call(String(v), /"/g, "&quot;");
  }
  function at(v) {
    return !X || !(typeof v == "object" && (X in v || typeof v[X] < "u"));
  }
  function vt(v) {
    return tt(v) === "[object Array]" && at(v);
  }
  function bt(v) {
    return tt(v) === "[object Date]" && at(v);
  }
  function L(v) {
    return tt(v) === "[object RegExp]" && at(v);
  }
  function G(v) {
    return tt(v) === "[object Error]" && at(v);
  }
  function F(v) {
    return tt(v) === "[object String]" && at(v);
  }
  function Y(v) {
    return tt(v) === "[object Number]" && at(v);
  }
  function H(v) {
    return tt(v) === "[object Boolean]" && at(v);
  }
  function ot(v) {
    if ($)
      return v && typeof v == "object" && v instanceof Symbol;
    if (typeof v == "symbol")
      return !0;
    if (!v || typeof v != "object" || !W)
      return !1;
    try {
      return W.call(v), !0;
    } catch {
    }
    return !1;
  }
  function B(v) {
    if (!v || typeof v != "object" || !A)
      return !1;
    try {
      return A.call(v), !0;
    } catch {
    }
    return !1;
  }
  var Dt = Object.prototype.hasOwnProperty || function(v) {
    return v in this;
  };
  function Z(v, S) {
    return Dt.call(v, S);
  }
  function tt(v) {
    return k.call(v);
  }
  function Tt(v) {
    if (v.name)
      return v.name;
    var S = a.call(T.call(v), /^function\s*([\w$]+)/);
    return S ? S[1] : null;
  }
  function it(v, S) {
    if (v.indexOf)
      return v.indexOf(S);
    for (var C = 0, U = v.length; C < U; C++)
      if (v[C] === S)
        return C;
    return -1;
  }
  function It(v) {
    if (!r || !v || typeof v != "object")
      return !1;
    try {
      r.call(v);
      try {
        c.call(v);
      } catch {
        return !0;
      }
      return v instanceof Map;
    } catch {
    }
    return !1;
  }
  function Nt(v) {
    if (!g || !v || typeof v != "object")
      return !1;
    try {
      g.call(v, g);
      try {
        E.call(v, E);
      } catch {
        return !0;
      }
      return v instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function jt(v) {
    if (!d || !v || typeof v != "object")
      return !1;
    try {
      return d.call(v), !0;
    } catch {
    }
    return !1;
  }
  function To(v) {
    if (!c || !v || typeof v != "object")
      return !1;
    try {
      c.call(v);
      try {
        r.call(v);
      } catch {
        return !0;
      }
      return v instanceof Set;
    } catch {
    }
    return !1;
  }
  function xo(v) {
    if (!E || !v || typeof v != "object")
      return !1;
    try {
      E.call(v, E);
      try {
        g.call(v, g);
      } catch {
        return !0;
      }
      return v instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function Po(v) {
    return !v || typeof v != "object" ? !1 : typeof HTMLElement < "u" && v instanceof HTMLElement ? !0 : typeof v.nodeName == "string" && typeof v.getAttribute == "function";
  }
  function Sr(v, S) {
    if (v.length > S.maxStringLength) {
      var C = v.length - S.maxStringLength, U = "... " + C + " more character" + (C > 1 ? "s" : "");
      return Sr(s.call(v, 0, S.maxStringLength), S) + U;
    }
    var q = gt[S.quoteStyle || "single"];
    q.lastIndex = 0;
    var I = o.call(o.call(v, q, "\\$1"), /[\x00-\x1f]/g, Ao);
    return wt(I, "single", S);
  }
  function Ao(v) {
    var S = v.charCodeAt(0), C = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[S];
    return C ? "\\" + C : "\\x" + (S < 16 ? "0" : "") + l.call(S.toString(16));
  }
  function Gt(v) {
    return "Object(" + v + ")";
  }
  function le(v) {
    return v + " { ? }";
  }
  function kr(v, S, C, U) {
    var q = U ? fe(C, U) : O.call(C, ", ");
    return v + " (" + S + ") {" + q + "}";
  }
  function Mo(v) {
    for (var S = 0; S < v.length; S++)
      if (it(v[S], `
`) >= 0)
        return !1;
    return !0;
  }
  function Do(v, S) {
    var C;
    if (v.indent === "	")
      C = "	";
    else if (typeof v.indent == "number" && v.indent > 0)
      C = O.call(Array(v.indent + 1), " ");
    else
      return null;
    return {
      base: C,
      prev: O.call(Array(S + 1), C)
    };
  }
  function fe(v, S) {
    if (v.length === 0)
      return "";
    var C = `
` + S.prev + S.base;
    return C + O.call(v, "," + C) + `
` + S.prev;
  }
  function Zt(v, S) {
    var C = vt(v), U = [];
    if (C) {
      U.length = v.length;
      for (var q = 0; q < v.length; q++)
        U[q] = Z(v, q) ? S(v[q], v) : "";
    }
    var I = typeof M == "function" ? M(v) : [], Et;
    if ($) {
      Et = {};
      for (var xt = 0; xt < I.length; xt++)
        Et["$" + I[xt]] = I[xt];
    }
    for (var et in v)
      Z(v, et) && (C && String(Number(et)) === et && et < v.length || $ && Et["$" + et] instanceof Symbol || (w.call(/[^\w$]/, et) ? U.push(S(et, v) + ": " + S(v[et], v)) : U.push(et + ": " + S(v[et], v))));
    if (typeof M == "function")
      for (var St = 0; St < I.length; St++)
        ft.call(v, I[St]) && U.push("[" + S(I[St]) + "]: " + S(v[I[St]], v));
    return U;
  }
  return ke;
}
var Oe, Kr;
function Pu() {
  if (Kr) return Oe;
  Kr = 1;
  var e = /* @__PURE__ */ ue(), t = /* @__PURE__ */ Ut(), r = function(f, b, g) {
    for (var y = f, E; (E = y.next) != null; y = E)
      if (E.key === b)
        return y.next = E.next, g || (E.next = /** @type {NonNullable<typeof list.next>} */
        f.next, f.next = E), E;
  }, n = function(f, b) {
    if (f) {
      var g = r(f, b);
      return g && g.value;
    }
  }, i = function(f, b, g) {
    var y = r(f, b);
    y ? y.value = g : f.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: b,
      next: f.next,
      value: g
    };
  }, u = function(f, b) {
    return f ? !!r(f, b) : !1;
  }, c = function(f, b) {
    if (f)
      return r(f, b, !0);
  };
  return Oe = function() {
    var f, b = {
      assert: function(g) {
        if (!b.has(g))
          throw new t("Side channel does not contain " + e(g));
      },
      delete: function(g) {
        var y = f && f.next, E = c(f, g);
        return E && y && y === E && (f = void 0), !!E;
      },
      get: function(g) {
        return n(f, g);
      },
      has: function(g) {
        return u(f, g);
      },
      set: function(g, y) {
        f || (f = {
          next: void 0
        }), i(
          /** @type {NonNullable<typeof $o>} */
          f,
          g,
          y
        );
      }
    };
    return b;
  }, Oe;
}
var Qr, Xr;
function uo() {
  return Xr || (Xr = 1, Qr = Object), Qr;
}
var Jr, Zr;
function Au() {
  return Zr || (Zr = 1, Jr = Error), Jr;
}
var tn, en;
function Mu() {
  return en || (en = 1, tn = EvalError), tn;
}
var rn, nn;
function Du() {
  return nn || (nn = 1, rn = RangeError), rn;
}
var an, on;
function Iu() {
  return on || (on = 1, an = ReferenceError), an;
}
var sn, un;
function Nu() {
  return un || (un = 1, sn = SyntaxError), sn;
}
var cn, ln;
function ju() {
  return ln || (ln = 1, cn = URIError), cn;
}
var fn, dn;
function _u() {
  return dn || (dn = 1, fn = Math.abs), fn;
}
var hn, pn;
function Ru() {
  return pn || (pn = 1, hn = Math.floor), hn;
}
var yn, mn;
function Cu() {
  return mn || (mn = 1, yn = Math.max), yn;
}
var gn, wn;
function Fu() {
  return wn || (wn = 1, gn = Math.min), gn;
}
var vn, bn;
function Wu() {
  return bn || (bn = 1, vn = Math.pow), vn;
}
var En, Sn;
function Lu() {
  return Sn || (Sn = 1, En = Math.round), En;
}
var kn, On;
function Uu() {
  return On || (On = 1, kn = Number.isNaN || function(e) {
    return e !== e;
  }), kn;
}
var Te, Tn;
function Gu() {
  if (Tn) return Te;
  Tn = 1;
  var e = /* @__PURE__ */ Uu();
  return Te = function(t) {
    return e(t) || t === 0 ? t : t < 0 ? -1 : 1;
  }, Te;
}
var xn, Pn;
function qu() {
  return Pn || (Pn = 1, xn = Object.getOwnPropertyDescriptor), xn;
}
var xe, An;
function co() {
  if (An) return xe;
  An = 1;
  var e = /* @__PURE__ */ qu();
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  return xe = e, xe;
}
var Pe, Mn;
function $u() {
  if (Mn) return Pe;
  Mn = 1;
  var e = Object.defineProperty || !1;
  if (e)
    try {
      e({}, "a", {
        value: 1
      });
    } catch {
      e = !1;
    }
  return Pe = e, Pe;
}
var Dn, In;
function Yu() {
  return In || (In = 1, Dn = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var e = {}, t = Symbol("test"), r = Object(t);
    if (typeof t == "string" || Object.prototype.toString.call(t) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]")
      return !1;
    var n = 42;
    e[t] = n;
    for (var i in e)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
      return !1;
    var u = Object.getOwnPropertySymbols(e);
    if (u.length !== 1 || u[0] !== t || !Object.prototype.propertyIsEnumerable.call(e, t))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var c = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(e, t)
      );
      if (c.value !== n || c.enumerable !== !0)
        return !1;
    }
    return !0;
  }), Dn;
}
var Ae, Nn;
function Bu() {
  if (Nn) return Ae;
  Nn = 1;
  var e = typeof Symbol < "u" && Symbol, t = Yu();
  return Ae = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, Ae;
}
var jn, _n;
function lo() {
  return _n || (_n = 1, jn = typeof Reflect < "u" && Reflect.getPrototypeOf || null), jn;
}
var Me, Rn;
function fo() {
  if (Rn) return Me;
  Rn = 1;
  var e = /* @__PURE__ */ uo();
  return Me = e.getPrototypeOf || null, Me;
}
var De, Cn;
function zu() {
  if (Cn) return De;
  Cn = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, r = Math.max, n = "[object Function]", i = function(f, b) {
    for (var g = [], y = 0; y < f.length; y += 1)
      g[y] = f[y];
    for (var E = 0; E < b.length; E += 1)
      g[E + f.length] = b[E];
    return g;
  }, u = function(f, b) {
    for (var g = [], y = b, E = 0; y < f.length; y += 1, E += 1)
      g[E] = f[y];
    return g;
  }, c = function(f, b) {
    for (var g = "", y = 0; y < f.length; y += 1)
      g += f[y], y + 1 < f.length && (g += b);
    return g;
  };
  return De = function(f) {
    var b = this;
    if (typeof b != "function" || t.apply(b) !== n)
      throw new TypeError(e + b);
    for (var g = u(arguments, 1), y, E = function() {
      if (this instanceof y) {
        var T = b.apply(this, i(g, arguments));
        return Object(T) === T ? T : this;
      }
      return b.apply(f, i(g, arguments));
    }, p = r(0, b.length - g.length), d = [], x = 0; x < p; x++)
      d[x] = "$" + x;
    if (y = Function("binder", "return function (" + c(d, ",") + "){ return binder.apply(this,arguments); }")(E), b.prototype) {
      var k = function() {
      };
      k.prototype = b.prototype, y.prototype = new k(), k.prototype = null;
    }
    return y;
  }, De;
}
var Ie, Fn;
function ce() {
  if (Fn) return Ie;
  Fn = 1;
  var e = zu();
  return Ie = Function.prototype.bind || e, Ie;
}
var Wn, Ln;
function vr() {
  return Ln || (Ln = 1, Wn = Function.prototype.call), Wn;
}
var Un, Gn;
function ho() {
  return Gn || (Gn = 1, Un = Function.prototype.apply), Un;
}
var qn, $n;
function Hu() {
  return $n || ($n = 1, qn = typeof Reflect < "u" && Reflect && Reflect.apply), qn;
}
var Ne, Yn;
function Vu() {
  if (Yn) return Ne;
  Yn = 1;
  var e = ce(), t = ho(), r = vr(), n = Hu();
  return Ne = n || e.call(r, t), Ne;
}
var je, Bn;
function po() {
  if (Bn) return je;
  Bn = 1;
  var e = ce(), t = /* @__PURE__ */ Ut(), r = vr(), n = Vu();
  return je = function(i) {
    if (i.length < 1 || typeof i[0] != "function")
      throw new t("a function is required");
    return n(e, r, i);
  }, je;
}
var _e, zn;
function Ku() {
  if (zn) return _e;
  zn = 1;
  var e = po(), t = /* @__PURE__ */ co(), r;
  try {
    r = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (c) {
    if (!c || typeof c != "object" || !("code" in c) || c.code !== "ERR_PROTO_ACCESS")
      throw c;
  }
  var n = !!r && t && t(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), i = Object, u = i.getPrototypeOf;
  return _e = n && typeof n.get == "function" ? e([n.get]) : typeof u == "function" ? (
    /** @type {import('./get')} */
    function(c) {
      return u(c == null ? c : i(c));
    }
  ) : !1, _e;
}
var Re, Hn;
function Qu() {
  if (Hn) return Re;
  Hn = 1;
  var e = lo(), t = fo(), r = /* @__PURE__ */ Ku();
  return Re = e ? function(n) {
    return e(n);
  } : t ? function(n) {
    if (!n || typeof n != "object" && typeof n != "function")
      throw new TypeError("getProto: not an object");
    return t(n);
  } : r ? function(n) {
    return r(n);
  } : null, Re;
}
var Ce, Vn;
function Xu() {
  if (Vn) return Ce;
  Vn = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, r = ce();
  return Ce = r.call(e, t), Ce;
}
var Fe, Kn;
function br() {
  if (Kn) return Fe;
  Kn = 1;
  var e, t = /* @__PURE__ */ uo(), r = /* @__PURE__ */ Au(), n = /* @__PURE__ */ Mu(), i = /* @__PURE__ */ Du(), u = /* @__PURE__ */ Iu(), c = /* @__PURE__ */ Nu(), f = /* @__PURE__ */ Ut(), b = /* @__PURE__ */ ju(), g = /* @__PURE__ */ _u(), y = /* @__PURE__ */ Ru(), E = /* @__PURE__ */ Cu(), p = /* @__PURE__ */ Fu(), d = /* @__PURE__ */ Wu(), x = /* @__PURE__ */ Lu(), k = /* @__PURE__ */ Gu(), T = Function, a = function(L) {
    try {
      return T('"use strict"; return (' + L + ").constructor;")();
    } catch {
    }
  }, s = /* @__PURE__ */ co(), o = /* @__PURE__ */ $u(), l = function() {
    throw new f();
  }, h = s ? function() {
    try {
      return arguments.callee, l;
    } catch {
      try {
        return s(arguments, "callee").get;
      } catch {
        return l;
      }
    }
  }() : l, w = Bu()(), m = Qu(), O = fo(), P = lo(), D = ho(), A = vr(), M = {}, W = typeof Uint8Array > "u" || !m ? e : m(Uint8Array), $ = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": w && m ? m([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": M,
    "%AsyncGenerator%": M,
    "%AsyncGeneratorFunction%": M,
    "%AsyncIteratorPrototype%": M,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": r,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": n,
    "%Float16Array%": typeof Float16Array > "u" ? e : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": T,
    "%GeneratorFunction%": M,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": w && m ? m(m([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !w || !m ? e : m((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": t,
    "%Object.getOwnPropertyDescriptor%": s,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": i,
    "%ReferenceError%": u,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !w || !m ? e : m((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": w && m ? m(""[Symbol.iterator]()) : e,
    "%Symbol%": w ? Symbol : e,
    "%SyntaxError%": c,
    "%ThrowTypeError%": h,
    "%TypedArray%": W,
    "%TypeError%": f,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": b,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet,
    "%Function.prototype.call%": A,
    "%Function.prototype.apply%": D,
    "%Object.defineProperty%": o,
    "%Object.getPrototypeOf%": O,
    "%Math.abs%": g,
    "%Math.floor%": y,
    "%Math.max%": E,
    "%Math.min%": p,
    "%Math.pow%": d,
    "%Math.round%": x,
    "%Math.sign%": k,
    "%Reflect.getPrototypeOf%": P
  };
  if (m)
    try {
      null.error;
    } catch (L) {
      var X = m(m(L));
      $["%Error.prototype%"] = X;
    }
  var ft = function L(G) {
    var F;
    if (G === "%AsyncFunction%")
      F = a("async function () {}");
    else if (G === "%GeneratorFunction%")
      F = a("function* () {}");
    else if (G === "%AsyncGeneratorFunction%")
      F = a("async function* () {}");
    else if (G === "%AsyncGenerator%") {
      var Y = L("%AsyncGeneratorFunction%");
      Y && (F = Y.prototype);
    } else if (G === "%AsyncIteratorPrototype%") {
      var H = L("%AsyncGenerator%");
      H && m && (F = m(H.prototype));
    }
    return $[G] = F, F;
  }, dt = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, j = ce(), J = /* @__PURE__ */ Xu(), ht = j.call(A, Array.prototype.concat), Ot = j.call(D, Array.prototype.splice), mt = j.call(A, String.prototype.replace), gt = j.call(A, String.prototype.slice), wt = j.call(A, RegExp.prototype.exec), pt = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, at = /\\(\\)?/g, vt = function(L) {
    var G = gt(L, 0, 1), F = gt(L, -1);
    if (G === "%" && F !== "%")
      throw new c("invalid intrinsic syntax, expected closing `%`");
    if (F === "%" && G !== "%")
      throw new c("invalid intrinsic syntax, expected opening `%`");
    var Y = [];
    return mt(L, pt, function(H, ot, B, Dt) {
      Y[Y.length] = B ? mt(Dt, at, "$1") : ot || H;
    }), Y;
  }, bt = function(L, G) {
    var F = L, Y;
    if (J(dt, F) && (Y = dt[F], F = "%" + Y[0] + "%"), J($, F)) {
      var H = $[F];
      if (H === M && (H = ft(F)), typeof H > "u" && !G)
        throw new f("intrinsic " + L + " exists, but is not available. Please file an issue!");
      return {
        alias: Y,
        name: F,
        value: H
      };
    }
    throw new c("intrinsic " + L + " does not exist!");
  };
  return Fe = function(L, G) {
    if (typeof L != "string" || L.length === 0)
      throw new f("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof G != "boolean")
      throw new f('"allowMissing" argument must be a boolean');
    if (wt(/^%?[^%]*%?$/, L) === null)
      throw new c("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var F = vt(L), Y = F.length > 0 ? F[0] : "", H = bt("%" + Y + "%", G), ot = H.name, B = H.value, Dt = !1, Z = H.alias;
    Z && (Y = Z[0], Ot(F, ht([0, 1], Z)));
    for (var tt = 1, Tt = !0; tt < F.length; tt += 1) {
      var it = F[tt], It = gt(it, 0, 1), Nt = gt(it, -1);
      if ((It === '"' || It === "'" || It === "`" || Nt === '"' || Nt === "'" || Nt === "`") && It !== Nt)
        throw new c("property names with quotes must have matching quotes");
      if ((it === "constructor" || !Tt) && (Dt = !0), Y += "." + it, ot = "%" + Y + "%", J($, ot))
        B = $[ot];
      else if (B != null) {
        if (!(it in B)) {
          if (!G)
            throw new f("base intrinsic for " + L + " exists, but the property is not available.");
          return;
        }
        if (s && tt + 1 >= F.length) {
          var jt = s(B, it);
          Tt = !!jt, Tt && "get" in jt && !("originalValue" in jt.get) ? B = jt.get : B = B[it];
        } else
          Tt = J(B, it), B = B[it];
        Tt && !Dt && ($[ot] = B);
      }
    }
    return B;
  }, Fe;
}
var We, Qn;
function yo() {
  if (Qn) return We;
  Qn = 1;
  var e = /* @__PURE__ */ br(), t = po(), r = t([e("%String.prototype.indexOf%")]);
  return We = function(n, i) {
    var u = (
      /** @type {Parameters<typeof callBindBasic>[0][0]} */
      e(n, !!i)
    );
    return typeof u == "function" && r(n, ".prototype.") > -1 ? t([u]) : u;
  }, We;
}
var Le, Xn;
function mo() {
  if (Xn) return Le;
  Xn = 1;
  var e = /* @__PURE__ */ br(), t = /* @__PURE__ */ yo(), r = /* @__PURE__ */ ue(), n = /* @__PURE__ */ Ut(), i = e("%Map%", !0), u = t("Map.prototype.get", !0), c = t("Map.prototype.set", !0), f = t("Map.prototype.has", !0), b = t("Map.prototype.delete", !0), g = t("Map.prototype.size", !0);
  return Le = !!i && /** @type {Exclude<import('.'), false>} */
  function() {
    var y, E = {
      assert: function(p) {
        if (!E.has(p))
          throw new n("Side channel does not contain " + r(p));
      },
      delete: function(p) {
        if (y) {
          var d = b(y, p);
          return g(y) === 0 && (y = void 0), d;
        }
        return !1;
      },
      get: function(p) {
        if (y)
          return u(y, p);
      },
      has: function(p) {
        return y ? f(y, p) : !1;
      },
      set: function(p, d) {
        y || (y = new i()), c(y, p, d);
      }
    };
    return E;
  }, Le;
}
var Ue, Jn;
function Ju() {
  if (Jn) return Ue;
  Jn = 1;
  var e = /* @__PURE__ */ br(), t = /* @__PURE__ */ yo(), r = /* @__PURE__ */ ue(), n = mo(), i = /* @__PURE__ */ Ut(), u = e("%WeakMap%", !0), c = t("WeakMap.prototype.get", !0), f = t("WeakMap.prototype.set", !0), b = t("WeakMap.prototype.has", !0), g = t("WeakMap.prototype.delete", !0);
  return Ue = u ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var y, E, p = {
        assert: function(d) {
          if (!p.has(d))
            throw new i("Side channel does not contain " + r(d));
        },
        delete: function(d) {
          if (u && d && (typeof d == "object" || typeof d == "function")) {
            if (y)
              return g(y, d);
          } else if (n && E)
            return E.delete(d);
          return !1;
        },
        get: function(d) {
          return u && d && (typeof d == "object" || typeof d == "function") && y ? c(y, d) : E && E.get(d);
        },
        has: function(d) {
          return u && d && (typeof d == "object" || typeof d == "function") && y ? b(y, d) : !!E && E.has(d);
        },
        set: function(d, x) {
          u && d && (typeof d == "object" || typeof d == "function") ? (y || (y = new u()), f(y, d, x)) : n && (E || (E = n()), E.set(d, x));
        }
      };
      return p;
    }
  ) : n, Ue;
}
var Ge, Zn;
function Zu() {
  if (Zn) return Ge;
  Zn = 1;
  var e = /* @__PURE__ */ Ut(), t = /* @__PURE__ */ ue(), r = Pu(), n = mo(), i = Ju(), u = i || n || r;
  return Ge = function() {
    var c, f = {
      assert: function(b) {
        if (!f.has(b))
          throw new e("Side channel does not contain " + t(b));
      },
      delete: function(b) {
        return !!c && c.delete(b);
      },
      get: function(b) {
        return c && c.get(b);
      },
      has: function(b) {
        return !!c && c.has(b);
      },
      set: function(b, g) {
        c || (c = u()), c.set(b, g);
      }
    };
    return f;
  }, Ge;
}
var qe, ta;
function Er() {
  if (ta) return qe;
  ta = 1;
  var e = String.prototype.replace, t = /%20/g, r = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return qe = {
    default: r.RFC3986,
    formatters: {
      RFC1738: function(n) {
        return e.call(n, t, "+");
      },
      RFC3986: function(n) {
        return String(n);
      }
    },
    RFC1738: r.RFC1738,
    RFC3986: r.RFC3986
  }, qe;
}
var $e, ea;
function go() {
  if (ea) return $e;
  ea = 1;
  var e = /* @__PURE__ */ Er(), t = Object.prototype.hasOwnProperty, r = Array.isArray, n = function() {
    for (var T = [], a = 0; a < 256; ++a)
      T.push("%" + ((a < 16 ? "0" : "") + a.toString(16)).toUpperCase());
    return T;
  }(), i = function(T) {
    for (; T.length > 1; ) {
      var a = T.pop(), s = a.obj[a.prop];
      if (r(s)) {
        for (var o = [], l = 0; l < s.length; ++l)
          typeof s[l] < "u" && o.push(s[l]);
        a.obj[a.prop] = o;
      }
    }
  }, u = function(T, a) {
    for (var s = a && a.plainObjects ? {
      __proto__: null
    } : {}, o = 0; o < T.length; ++o)
      typeof T[o] < "u" && (s[o] = T[o]);
    return s;
  }, c = function T(a, s, o) {
    if (!s)
      return a;
    if (typeof s != "object" && typeof s != "function") {
      if (r(a))
        a.push(s);
      else if (a && typeof a == "object")
        (o && (o.plainObjects || o.allowPrototypes) || !t.call(Object.prototype, s)) && (a[s] = !0);
      else
        return [a, s];
      return a;
    }
    if (!a || typeof a != "object")
      return [a].concat(s);
    var l = a;
    return r(a) && !r(s) && (l = u(a, o)), r(a) && r(s) ? (s.forEach(function(h, w) {
      if (t.call(a, w)) {
        var m = a[w];
        m && typeof m == "object" && h && typeof h == "object" ? a[w] = T(m, h, o) : a.push(h);
      } else
        a[w] = h;
    }), a) : Object.keys(s).reduce(function(h, w) {
      var m = s[w];
      return t.call(h, w) ? h[w] = T(h[w], m, o) : h[w] = m, h;
    }, l);
  }, f = function(T, a) {
    return Object.keys(a).reduce(function(s, o) {
      return s[o] = a[o], s;
    }, T);
  }, b = function(T, a, s) {
    var o = T.replace(/\+/g, " ");
    if (s === "iso-8859-1")
      return o.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(o);
    } catch {
      return o;
    }
  }, g = 1024, y = function(T, a, s, o, l) {
    if (T.length === 0)
      return T;
    var h = T;
    if (typeof T == "symbol" ? h = Symbol.prototype.toString.call(T) : typeof T != "string" && (h = String(T)), s === "iso-8859-1")
      return escape(h).replace(/%u[0-9a-f]{4}/gi, function(M) {
        return "%26%23" + parseInt(M.slice(2), 16) + "%3B";
      });
    for (var w = "", m = 0; m < h.length; m += g) {
      for (var O = h.length >= g ? h.slice(m, m + g) : h, P = [], D = 0; D < O.length; ++D) {
        var A = O.charCodeAt(D);
        if (A === 45 || A === 46 || A === 95 || A === 126 || A >= 48 && A <= 57 || A >= 65 && A <= 90 || A >= 97 && A <= 122 || l === e.RFC1738 && (A === 40 || A === 41)) {
          P[P.length] = O.charAt(D);
          continue;
        }
        if (A < 128) {
          P[P.length] = n[A];
          continue;
        }
        if (A < 2048) {
          P[P.length] = n[192 | A >> 6] + n[128 | A & 63];
          continue;
        }
        if (A < 55296 || A >= 57344) {
          P[P.length] = n[224 | A >> 12] + n[128 | A >> 6 & 63] + n[128 | A & 63];
          continue;
        }
        D += 1, A = 65536 + ((A & 1023) << 10 | O.charCodeAt(D) & 1023), P[P.length] = n[240 | A >> 18] + n[128 | A >> 12 & 63] + n[128 | A >> 6 & 63] + n[128 | A & 63];
      }
      w += P.join("");
    }
    return w;
  }, E = function(T) {
    for (var a = [{
      obj: {
        o: T
      },
      prop: "o"
    }], s = [], o = 0; o < a.length; ++o)
      for (var l = a[o], h = l.obj[l.prop], w = Object.keys(h), m = 0; m < w.length; ++m) {
        var O = w[m], P = h[O];
        typeof P == "object" && P !== null && s.indexOf(P) === -1 && (a.push({
          obj: h,
          prop: O
        }), s.push(P));
      }
    return i(a), T;
  }, p = function(T) {
    return Object.prototype.toString.call(T) === "[object RegExp]";
  }, d = function(T) {
    return !T || typeof T != "object" ? !1 : !!(T.constructor && T.constructor.isBuffer && T.constructor.isBuffer(T));
  }, x = function(T, a) {
    return [].concat(T, a);
  }, k = function(T, a) {
    if (r(T)) {
      for (var s = [], o = 0; o < T.length; o += 1)
        s.push(a(T[o]));
      return s;
    }
    return a(T);
  };
  return $e = {
    arrayToObject: u,
    assign: f,
    combine: x,
    compact: E,
    decode: b,
    encode: y,
    isBuffer: d,
    isRegExp: p,
    maybeMap: k,
    merge: c
  }, $e;
}
var Ye, ra;
function tc() {
  if (ra) return Ye;
  ra = 1;
  var e = Zu(), t = /* @__PURE__ */ go(), r = /* @__PURE__ */ Er(), n = Object.prototype.hasOwnProperty, i = {
    brackets: function(k) {
      return k + "[]";
    },
    comma: "comma",
    indices: function(k, T) {
      return k + "[" + T + "]";
    },
    repeat: function(k) {
      return k;
    }
  }, u = Array.isArray, c = Array.prototype.push, f = function(k, T) {
    c.apply(k, u(T) ? T : [T]);
  }, b = Date.prototype.toISOString, g = r.default, y = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: t.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: g,
    formatter: r.formatters[g],
    // deprecated
    indices: !1,
    serializeDate: function(k) {
      return b.call(k);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, E = function(k) {
    return typeof k == "string" || typeof k == "number" || typeof k == "boolean" || typeof k == "symbol" || typeof k == "bigint";
  }, p = {}, d = function k(T, a, s, o, l, h, w, m, O, P, D, A, M, W, $, X, ft, dt) {
    for (var j = T, J = dt, ht = 0, Ot = !1; (J = J.get(p)) !== void 0 && !Ot; ) {
      var mt = J.get(T);
      if (ht += 1, typeof mt < "u") {
        if (mt === ht)
          throw new RangeError("Cyclic object value");
        Ot = !0;
      }
      typeof J.get(p) > "u" && (ht = 0);
    }
    if (typeof P == "function" ? j = P(a, j) : j instanceof Date ? j = M(j) : s === "comma" && u(j) && (j = t.maybeMap(j, function(B) {
      return B instanceof Date ? M(B) : B;
    })), j === null) {
      if (h)
        return O && !X ? O(a, y.encoder, ft, "key", W) : a;
      j = "";
    }
    if (E(j) || t.isBuffer(j)) {
      if (O) {
        var gt = X ? a : O(a, y.encoder, ft, "key", W);
        return [$(gt) + "=" + $(O(j, y.encoder, ft, "value", W))];
      }
      return [$(a) + "=" + $(String(j))];
    }
    var wt = [];
    if (typeof j > "u")
      return wt;
    var pt;
    if (s === "comma" && u(j))
      X && O && (j = t.maybeMap(j, O)), pt = [{
        value: j.length > 0 ? j.join(",") || null : void 0
      }];
    else if (u(P))
      pt = P;
    else {
      var at = Object.keys(j);
      pt = D ? at.sort(D) : at;
    }
    var vt = m ? String(a).replace(/\./g, "%2E") : String(a), bt = o && u(j) && j.length === 1 ? vt + "[]" : vt;
    if (l && u(j) && j.length === 0)
      return bt + "[]";
    for (var L = 0; L < pt.length; ++L) {
      var G = pt[L], F = typeof G == "object" && G && typeof G.value < "u" ? G.value : j[G];
      if (!(w && F === null)) {
        var Y = A && m ? String(G).replace(/\./g, "%2E") : String(G), H = u(j) ? typeof s == "function" ? s(bt, Y) : bt : bt + (A ? "." + Y : "[" + Y + "]");
        dt.set(T, ht);
        var ot = e();
        ot.set(p, dt), f(wt, k(F, H, s, o, l, h, w, m, s === "comma" && X && u(j) ? null : O, P, D, A, M, W, $, X, ft, ot));
      }
    }
    return wt;
  }, x = function(k) {
    if (!k)
      return y;
    if (typeof k.allowEmptyArrays < "u" && typeof k.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof k.encodeDotInKeys < "u" && typeof k.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (k.encoder !== null && typeof k.encoder < "u" && typeof k.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var T = k.charset || y.charset;
    if (typeof k.charset < "u" && k.charset !== "utf-8" && k.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var a = r.default;
    if (typeof k.format < "u") {
      if (!n.call(r.formatters, k.format))
        throw new TypeError("Unknown format option provided.");
      a = k.format;
    }
    var s = r.formatters[a], o = y.filter;
    (typeof k.filter == "function" || u(k.filter)) && (o = k.filter);
    var l;
    if (k.arrayFormat in i ? l = k.arrayFormat : "indices" in k ? l = k.indices ? "indices" : "repeat" : l = y.arrayFormat, "commaRoundTrip" in k && typeof k.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var h = typeof k.allowDots > "u" ? k.encodeDotInKeys === !0 ? !0 : y.allowDots : !!k.allowDots;
    return {
      addQueryPrefix: typeof k.addQueryPrefix == "boolean" ? k.addQueryPrefix : y.addQueryPrefix,
      allowDots: h,
      allowEmptyArrays: typeof k.allowEmptyArrays == "boolean" ? !!k.allowEmptyArrays : y.allowEmptyArrays,
      arrayFormat: l,
      charset: T,
      charsetSentinel: typeof k.charsetSentinel == "boolean" ? k.charsetSentinel : y.charsetSentinel,
      commaRoundTrip: !!k.commaRoundTrip,
      delimiter: typeof k.delimiter > "u" ? y.delimiter : k.delimiter,
      encode: typeof k.encode == "boolean" ? k.encode : y.encode,
      encodeDotInKeys: typeof k.encodeDotInKeys == "boolean" ? k.encodeDotInKeys : y.encodeDotInKeys,
      encoder: typeof k.encoder == "function" ? k.encoder : y.encoder,
      encodeValuesOnly: typeof k.encodeValuesOnly == "boolean" ? k.encodeValuesOnly : y.encodeValuesOnly,
      filter: o,
      format: a,
      formatter: s,
      serializeDate: typeof k.serializeDate == "function" ? k.serializeDate : y.serializeDate,
      skipNulls: typeof k.skipNulls == "boolean" ? k.skipNulls : y.skipNulls,
      sort: typeof k.sort == "function" ? k.sort : null,
      strictNullHandling: typeof k.strictNullHandling == "boolean" ? k.strictNullHandling : y.strictNullHandling
    };
  };
  return Ye = function(k, T) {
    var a = k, s = x(T), o, l;
    typeof s.filter == "function" ? (l = s.filter, a = l("", a)) : u(s.filter) && (l = s.filter, o = l);
    var h = [];
    if (typeof a != "object" || a === null)
      return "";
    var w = i[s.arrayFormat], m = w === "comma" && s.commaRoundTrip;
    o || (o = Object.keys(a)), s.sort && o.sort(s.sort);
    for (var O = e(), P = 0; P < o.length; ++P) {
      var D = o[P], A = a[D];
      s.skipNulls && A === null || f(h, d(A, D, w, m, s.allowEmptyArrays, s.strictNullHandling, s.skipNulls, s.encodeDotInKeys, s.encode ? s.encoder : null, s.filter, s.sort, s.allowDots, s.serializeDate, s.format, s.formatter, s.encodeValuesOnly, s.charset, O));
    }
    var M = h.join(s.delimiter), W = s.addQueryPrefix === !0 ? "?" : "";
    return s.charsetSentinel && (s.charset === "iso-8859-1" ? W += "utf8=%26%2310003%3B&" : W += "utf8=%E2%9C%93&"), M.length > 0 ? W + M : "";
  }, Ye;
}
var Be, na;
function ec() {
  if (na) return Be;
  na = 1;
  var e = /* @__PURE__ */ go(), t = Object.prototype.hasOwnProperty, r = Array.isArray, n = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: e.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  }, i = function(p) {
    return p.replace(/&#(\d+);/g, function(d, x) {
      return String.fromCharCode(parseInt(x, 10));
    });
  }, u = function(p, d, x) {
    if (p && typeof p == "string" && d.comma && p.indexOf(",") > -1)
      return p.split(",");
    if (d.throwOnLimitExceeded && x >= d.arrayLimit)
      throw new RangeError("Array limit exceeded. Only " + d.arrayLimit + " element" + (d.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
    return p;
  }, c = "utf8=%26%2310003%3B", f = "utf8=%E2%9C%93", b = function(p, d) {
    var x = {
      __proto__: null
    }, k = d.ignoreQueryPrefix ? p.replace(/^\?/, "") : p;
    k = k.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var T = d.parameterLimit === 1 / 0 ? void 0 : d.parameterLimit, a = k.split(d.delimiter, d.throwOnLimitExceeded ? T + 1 : T);
    if (d.throwOnLimitExceeded && a.length > T)
      throw new RangeError("Parameter limit exceeded. Only " + T + " parameter" + (T === 1 ? "" : "s") + " allowed.");
    var s = -1, o, l = d.charset;
    if (d.charsetSentinel)
      for (o = 0; o < a.length; ++o)
        a[o].indexOf("utf8=") === 0 && (a[o] === f ? l = "utf-8" : a[o] === c && (l = "iso-8859-1"), s = o, o = a.length);
    for (o = 0; o < a.length; ++o)
      if (o !== s) {
        var h = a[o], w = h.indexOf("]="), m = w === -1 ? h.indexOf("=") : w + 1, O, P;
        m === -1 ? (O = d.decoder(h, n.decoder, l, "key"), P = d.strictNullHandling ? null : "") : (O = d.decoder(h.slice(0, m), n.decoder, l, "key"), P = e.maybeMap(u(h.slice(m + 1), d, r(x[O]) ? x[O].length : 0), function(A) {
          return d.decoder(A, n.decoder, l, "value");
        })), P && d.interpretNumericEntities && l === "iso-8859-1" && (P = i(String(P))), h.indexOf("[]=") > -1 && (P = r(P) ? [P] : P);
        var D = t.call(x, O);
        D && d.duplicates === "combine" ? x[O] = e.combine(x[O], P) : (!D || d.duplicates === "last") && (x[O] = P);
      }
    return x;
  }, g = function(p, d, x, k) {
    var T = 0;
    if (p.length > 0 && p[p.length - 1] === "[]") {
      var a = p.slice(0, -1).join("");
      T = Array.isArray(d) && d[a] ? d[a].length : 0;
    }
    for (var s = k ? d : u(d, x, T), o = p.length - 1; o >= 0; --o) {
      var l, h = p[o];
      if (h === "[]" && x.parseArrays)
        l = x.allowEmptyArrays && (s === "" || x.strictNullHandling && s === null) ? [] : e.combine([], s);
      else {
        l = x.plainObjects ? {
          __proto__: null
        } : {};
        var w = h.charAt(0) === "[" && h.charAt(h.length - 1) === "]" ? h.slice(1, -1) : h, m = x.decodeDotInKeys ? w.replace(/%2E/g, ".") : w, O = parseInt(m, 10);
        !x.parseArrays && m === "" ? l = {
          0: s
        } : !isNaN(O) && h !== m && String(O) === m && O >= 0 && x.parseArrays && O <= x.arrayLimit ? (l = [], l[O] = s) : m !== "__proto__" && (l[m] = s);
      }
      s = l;
    }
    return s;
  }, y = function(p, d, x, k) {
    if (p) {
      var T = x.allowDots ? p.replace(/\.([^.[]+)/g, "[$1]") : p, a = /(\[[^[\]]*])/, s = /(\[[^[\]]*])/g, o = x.depth > 0 && a.exec(T), l = o ? T.slice(0, o.index) : T, h = [];
      if (l) {
        if (!x.plainObjects && t.call(Object.prototype, l) && !x.allowPrototypes)
          return;
        h.push(l);
      }
      for (var w = 0; x.depth > 0 && (o = s.exec(T)) !== null && w < x.depth; ) {
        if (w += 1, !x.plainObjects && t.call(Object.prototype, o[1].slice(1, -1)) && !x.allowPrototypes)
          return;
        h.push(o[1]);
      }
      if (o) {
        if (x.strictDepth === !0)
          throw new RangeError("Input depth exceeded depth option of " + x.depth + " and strictDepth is true");
        h.push("[" + T.slice(o.index) + "]");
      }
      return g(h, d, x, k);
    }
  }, E = function(p) {
    if (!p)
      return n;
    if (typeof p.allowEmptyArrays < "u" && typeof p.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof p.decodeDotInKeys < "u" && typeof p.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (p.decoder !== null && typeof p.decoder < "u" && typeof p.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof p.charset < "u" && p.charset !== "utf-8" && p.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    if (typeof p.throwOnLimitExceeded < "u" && typeof p.throwOnLimitExceeded != "boolean")
      throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
    var d = typeof p.charset > "u" ? n.charset : p.charset, x = typeof p.duplicates > "u" ? n.duplicates : p.duplicates;
    if (x !== "combine" && x !== "first" && x !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var k = typeof p.allowDots > "u" ? p.decodeDotInKeys === !0 ? !0 : n.allowDots : !!p.allowDots;
    return {
      allowDots: k,
      allowEmptyArrays: typeof p.allowEmptyArrays == "boolean" ? !!p.allowEmptyArrays : n.allowEmptyArrays,
      allowPrototypes: typeof p.allowPrototypes == "boolean" ? p.allowPrototypes : n.allowPrototypes,
      allowSparse: typeof p.allowSparse == "boolean" ? p.allowSparse : n.allowSparse,
      arrayLimit: typeof p.arrayLimit == "number" ? p.arrayLimit : n.arrayLimit,
      charset: d,
      charsetSentinel: typeof p.charsetSentinel == "boolean" ? p.charsetSentinel : n.charsetSentinel,
      comma: typeof p.comma == "boolean" ? p.comma : n.comma,
      decodeDotInKeys: typeof p.decodeDotInKeys == "boolean" ? p.decodeDotInKeys : n.decodeDotInKeys,
      decoder: typeof p.decoder == "function" ? p.decoder : n.decoder,
      delimiter: typeof p.delimiter == "string" || e.isRegExp(p.delimiter) ? p.delimiter : n.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof p.depth == "number" || p.depth === !1 ? +p.depth : n.depth,
      duplicates: x,
      ignoreQueryPrefix: p.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof p.interpretNumericEntities == "boolean" ? p.interpretNumericEntities : n.interpretNumericEntities,
      parameterLimit: typeof p.parameterLimit == "number" ? p.parameterLimit : n.parameterLimit,
      parseArrays: p.parseArrays !== !1,
      plainObjects: typeof p.plainObjects == "boolean" ? p.plainObjects : n.plainObjects,
      strictDepth: typeof p.strictDepth == "boolean" ? !!p.strictDepth : n.strictDepth,
      strictNullHandling: typeof p.strictNullHandling == "boolean" ? p.strictNullHandling : n.strictNullHandling,
      throwOnLimitExceeded: typeof p.throwOnLimitExceeded == "boolean" ? p.throwOnLimitExceeded : !1
    };
  };
  return Be = function(p, d) {
    var x = E(d);
    if (p === "" || p === null || typeof p > "u")
      return x.plainObjects ? {
        __proto__: null
      } : {};
    for (var k = typeof p == "string" ? b(p, x) : p, T = x.plainObjects ? {
      __proto__: null
    } : {}, a = Object.keys(k), s = 0; s < a.length; ++s) {
      var o = a[s], l = y(o, k[o], x, typeof p == "string");
      T = e.merge(T, l, x);
    }
    return x.allowSparse === !0 ? T : e.compact(T);
  }, Be;
}
var ze, aa;
function rc() {
  if (aa) return ze;
  aa = 1;
  var e = /* @__PURE__ */ tc(), t = /* @__PURE__ */ ec(), r = /* @__PURE__ */ Er();
  return ze = {
    formats: r,
    parse: t,
    stringify: e
  }, ze;
}
var nc = /* @__PURE__ */ rc(), ne = { exports: {} }, oa, ia;
function wo() {
  return ia || (ia = 1, oa = function(e, t) {
    return function() {
      for (var r = new Array(arguments.length), n = 0; n < r.length; n++)
        r[n] = arguments[n];
      return e.apply(t, r);
    };
  }), oa;
}
var He, sa;
function nt() {
  if (sa) return He;
  sa = 1;
  var e = wo(), t = Object.prototype.toString;
  function r(m) {
    return t.call(m) === "[object Array]";
  }
  function n(m) {
    return typeof m > "u";
  }
  function i(m) {
    return m !== null && !n(m) && m.constructor !== null && !n(m.constructor) && typeof m.constructor.isBuffer == "function" && m.constructor.isBuffer(m);
  }
  function u(m) {
    return t.call(m) === "[object ArrayBuffer]";
  }
  function c(m) {
    return typeof FormData < "u" && m instanceof FormData;
  }
  function f(m) {
    var O;
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? O = ArrayBuffer.isView(m) : O = m && m.buffer && m.buffer instanceof ArrayBuffer, O;
  }
  function b(m) {
    return typeof m == "string";
  }
  function g(m) {
    return typeof m == "number";
  }
  function y(m) {
    return m !== null && typeof m == "object";
  }
  function E(m) {
    return t.call(m) === "[object Date]";
  }
  function p(m) {
    return t.call(m) === "[object File]";
  }
  function d(m) {
    return t.call(m) === "[object Blob]";
  }
  function x(m) {
    return t.call(m) === "[object Function]";
  }
  function k(m) {
    return y(m) && x(m.pipe);
  }
  function T(m) {
    return typeof URLSearchParams < "u" && m instanceof URLSearchParams;
  }
  function a(m) {
    return m.replace(/^\s*/, "").replace(/\s*$/, "");
  }
  function s() {
    return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
  }
  function o(m, O) {
    if (!(m === null || typeof m > "u"))
      if (typeof m != "object" && (m = [m]), r(m))
        for (var P = 0, D = m.length; P < D; P++)
          O.call(null, m[P], P, m);
      else
        for (var A in m)
          Object.prototype.hasOwnProperty.call(m, A) && O.call(null, m[A], A, m);
  }
  function l() {
    var m = {};
    function O(A, M) {
      typeof m[M] == "object" && typeof A == "object" ? m[M] = l(m[M], A) : m[M] = A;
    }
    for (var P = 0, D = arguments.length; P < D; P++)
      o(arguments[P], O);
    return m;
  }
  function h() {
    var m = {};
    function O(A, M) {
      typeof m[M] == "object" && typeof A == "object" ? m[M] = h(m[M], A) : typeof A == "object" ? m[M] = h({}, A) : m[M] = A;
    }
    for (var P = 0, D = arguments.length; P < D; P++)
      o(arguments[P], O);
    return m;
  }
  function w(m, O, P) {
    return o(O, function(D, A) {
      P && typeof D == "function" ? m[A] = e(D, P) : m[A] = D;
    }), m;
  }
  return He = {
    isArray: r,
    isArrayBuffer: u,
    isBuffer: i,
    isFormData: c,
    isArrayBufferView: f,
    isString: b,
    isNumber: g,
    isObject: y,
    isUndefined: n,
    isDate: E,
    isFile: p,
    isBlob: d,
    isFunction: x,
    isStream: k,
    isURLSearchParams: T,
    isStandardBrowserEnv: s,
    forEach: o,
    merge: l,
    deepMerge: h,
    extend: w,
    trim: a
  }, He;
}
var Ve, ua;
function vo() {
  if (ua) return Ve;
  ua = 1;
  var e = nt();
  function t(r) {
    return encodeURIComponent(r).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  }
  return Ve = function(r, n, i) {
    if (!n)
      return r;
    var u;
    if (i)
      u = i(n);
    else if (e.isURLSearchParams(n))
      u = n.toString();
    else {
      var c = [];
      e.forEach(n, function(b, g) {
        b === null || typeof b > "u" || (e.isArray(b) ? g = g + "[]" : b = [b], e.forEach(b, function(y) {
          e.isDate(y) ? y = y.toISOString() : e.isObject(y) && (y = JSON.stringify(y)), c.push(t(g) + "=" + t(y));
        }));
      }), u = c.join("&");
    }
    if (u) {
      var f = r.indexOf("#");
      f !== -1 && (r = r.slice(0, f)), r += (r.indexOf("?") === -1 ? "?" : "&") + u;
    }
    return r;
  }, Ve;
}
var Ke, ca;
function ac() {
  if (ca) return Ke;
  ca = 1;
  var e = nt();
  function t() {
    this.handlers = [];
  }
  return t.prototype.use = function(r, n) {
    return this.handlers.push({
      fulfilled: r,
      rejected: n
    }), this.handlers.length - 1;
  }, t.prototype.eject = function(r) {
    this.handlers[r] && (this.handlers[r] = null);
  }, t.prototype.forEach = function(r) {
    e.forEach(this.handlers, function(n) {
      n !== null && r(n);
    });
  }, Ke = t, Ke;
}
var Qe, la;
function oc() {
  if (la) return Qe;
  la = 1;
  var e = nt();
  return Qe = function(t, r, n) {
    return e.forEach(n, function(i) {
      t = i(t, r);
    }), t;
  }, Qe;
}
var fa, da;
function bo() {
  return da || (da = 1, fa = function(e) {
    return !!(e && e.__CANCEL__);
  }), fa;
}
var Xe, ha;
function ic() {
  if (ha) return Xe;
  ha = 1;
  var e = nt();
  return Xe = function(t, r) {
    e.forEach(t, function(n, i) {
      i !== r && i.toUpperCase() === r.toUpperCase() && (t[r] = n, delete t[i]);
    });
  }, Xe;
}
var pa, ya;
function sc() {
  return ya || (ya = 1, pa = function(e, t, r, n, i) {
    return e.config = t, r && (e.code = r), e.request = n, e.response = i, e.isAxiosError = !0, e.toJSON = function() {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: this.config,
        code: this.code
      };
    }, e;
  }), pa;
}
var Je, ma;
function Eo() {
  if (ma) return Je;
  ma = 1;
  var e = sc();
  return Je = function(t, r, n, i, u) {
    var c = new Error(t);
    return e(c, r, n, i, u);
  }, Je;
}
var Ze, ga;
function uc() {
  if (ga) return Ze;
  ga = 1;
  var e = Eo();
  return Ze = function(t, r, n) {
    var i = n.config.validateStatus;
    !i || i(n.status) ? t(n) : r(e("Request failed with status code " + n.status, n.config, null, n.request, n));
  }, Ze;
}
var wa, va;
function cc() {
  return va || (va = 1, wa = function(e) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
  }), wa;
}
var ba, Ea;
function lc() {
  return Ea || (Ea = 1, ba = function(e, t) {
    return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
  }), ba;
}
var tr, Sa;
function fc() {
  if (Sa) return tr;
  Sa = 1;
  var e = cc(), t = lc();
  return tr = function(r, n) {
    return r && !e(n) ? t(r, n) : n;
  }, tr;
}
var er, ka;
function dc() {
  if (ka) return er;
  ka = 1;
  var e = nt(), t = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];
  return er = function(r) {
    var n = {}, i, u, c;
    return r && e.forEach(r.split(`
`), function(f) {
      if (c = f.indexOf(":"), i = e.trim(f.substr(0, c)).toLowerCase(), u = e.trim(f.substr(c + 1)), i) {
        if (n[i] && t.indexOf(i) >= 0)
          return;
        i === "set-cookie" ? n[i] = (n[i] ? n[i] : []).concat([u]) : n[i] = n[i] ? n[i] + ", " + u : u;
      }
    }), n;
  }, er;
}
var rr, Oa;
function hc() {
  if (Oa) return rr;
  Oa = 1;
  var e = nt();
  return rr = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var t = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a"), n;
      function i(u) {
        var c = u;
        return t && (r.setAttribute("href", c), c = r.href), r.setAttribute("href", c), {
          href: r.href,
          protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
          host: r.host,
          search: r.search ? r.search.replace(/^\?/, "") : "",
          hash: r.hash ? r.hash.replace(/^#/, "") : "",
          hostname: r.hostname,
          port: r.port,
          pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
        };
      }
      return n = i(window.location.href), function(u) {
        var c = e.isString(u) ? i(u) : u;
        return c.protocol === n.protocol && c.host === n.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return function() {
        return !0;
      };
    }()
  ), rr;
}
var nr, Ta;
function pc() {
  if (Ta) return nr;
  Ta = 1;
  var e = nt();
  return nr = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ function() {
      return {
        write: function(t, r, n, i, u, c) {
          var f = [];
          f.push(t + "=" + encodeURIComponent(r)), e.isNumber(n) && f.push("expires=" + new Date(n).toGMTString()), e.isString(i) && f.push("path=" + i), e.isString(u) && f.push("domain=" + u), c === !0 && f.push("secure"), document.cookie = f.join("; ");
        },
        read: function(t) {
          var r = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
          return r ? decodeURIComponent(r[3]) : null;
        },
        remove: function(t) {
          this.write(t, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), nr;
}
var ar, xa;
function yc() {
  if (xa) return ar;
  xa = 1;
  var e = nt(), t = uc(), r = vo(), n = fc(), i = dc(), u = hc(), c = Eo();
  return ar = function(f) {
    return new Promise(function(b, g) {
      var y = f.data, E = f.headers;
      e.isFormData(y) && delete E["Content-Type"];
      var p = new XMLHttpRequest();
      if (f.auth) {
        var d = f.auth.username || "", x = f.auth.password || "";
        E.Authorization = "Basic " + btoa(d + ":" + x);
      }
      var k = n(f.baseURL, f.url);
      if (p.open(f.method.toUpperCase(), r(k, f.params, f.paramsSerializer), !0), p.timeout = f.timeout, p.onreadystatechange = function() {
        if (!(!p || p.readyState !== 4) && !(p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0))) {
          var s = "getAllResponseHeaders" in p ? i(p.getAllResponseHeaders()) : null, o = !f.responseType || f.responseType === "text" ? p.responseText : p.response, l = {
            data: o,
            status: p.status,
            statusText: p.statusText,
            headers: s,
            config: f,
            request: p
          };
          t(b, g, l), p = null;
        }
      }, p.onabort = function() {
        p && (g(c("Request aborted", f, "ECONNABORTED", p)), p = null);
      }, p.onerror = function() {
        g(c("Network Error", f, null, p)), p = null;
      }, p.ontimeout = function() {
        var s = "timeout of " + f.timeout + "ms exceeded";
        f.timeoutErrorMessage && (s = f.timeoutErrorMessage), g(c(s, f, "ECONNABORTED", p)), p = null;
      }, e.isStandardBrowserEnv()) {
        var T = pc(), a = (f.withCredentials || u(k)) && f.xsrfCookieName ? T.read(f.xsrfCookieName) : void 0;
        a && (E[f.xsrfHeaderName] = a);
      }
      if ("setRequestHeader" in p && e.forEach(E, function(s, o) {
        typeof y > "u" && o.toLowerCase() === "content-type" ? delete E[o] : p.setRequestHeader(o, s);
      }), e.isUndefined(f.withCredentials) || (p.withCredentials = !!f.withCredentials), f.responseType)
        try {
          p.responseType = f.responseType;
        } catch (s) {
          if (f.responseType !== "json")
            throw s;
        }
      typeof f.onDownloadProgress == "function" && p.addEventListener("progress", f.onDownloadProgress), typeof f.onUploadProgress == "function" && p.upload && p.upload.addEventListener("progress", f.onUploadProgress), f.cancelToken && f.cancelToken.promise.then(function(s) {
        p && (p.abort(), g(s), p = null);
      }), y === void 0 && (y = null), p.send(y);
    });
  }, ar;
}
var or, Pa;
function So() {
  if (Pa) return or;
  Pa = 1;
  var e = nt(), t = ic(), r = {
    "Content-Type": "application/x-www-form-urlencoded"
  };
  function n(c, f) {
    !e.isUndefined(c) && e.isUndefined(c["Content-Type"]) && (c["Content-Type"] = f);
  }
  function i() {
    var c;
    return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (c = yc()), c;
  }
  var u = {
    adapter: i(),
    transformRequest: [function(c, f) {
      return t(f, "Accept"), t(f, "Content-Type"), e.isFormData(c) || e.isArrayBuffer(c) || e.isBuffer(c) || e.isStream(c) || e.isFile(c) || e.isBlob(c) ? c : e.isArrayBufferView(c) ? c.buffer : e.isURLSearchParams(c) ? (n(f, "application/x-www-form-urlencoded;charset=utf-8"), c.toString()) : e.isObject(c) ? (n(f, "application/json;charset=utf-8"), JSON.stringify(c)) : c;
    }],
    transformResponse: [function(c) {
      if (typeof c == "string")
        try {
          c = JSON.parse(c);
        } catch {
        }
      return c;
    }],
    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    validateStatus: function(c) {
      return c >= 200 && c < 300;
    }
  };
  return u.headers = {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }, e.forEach(["delete", "get", "head"], function(c) {
    u.headers[c] = {};
  }), e.forEach(["post", "put", "patch"], function(c) {
    u.headers[c] = e.merge(r);
  }), or = u, or;
}
var ir, Aa;
function mc() {
  if (Aa) return ir;
  Aa = 1;
  var e = nt(), t = oc(), r = bo(), n = So();
  function i(u) {
    u.cancelToken && u.cancelToken.throwIfRequested();
  }
  return ir = function(u) {
    i(u), u.headers = u.headers || {}, u.data = t(u.data, u.headers, u.transformRequest), u.headers = e.merge(u.headers.common || {}, u.headers[u.method] || {}, u.headers), e.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function(f) {
      delete u.headers[f];
    });
    var c = u.adapter || n.adapter;
    return c(u).then(function(f) {
      return i(u), f.data = t(f.data, f.headers, u.transformResponse), f;
    }, function(f) {
      return r(f) || (i(u), f && f.response && (f.response.data = t(f.response.data, f.response.headers, u.transformResponse))), Promise.reject(f);
    });
  }, ir;
}
var sr, Ma;
function ko() {
  if (Ma) return sr;
  Ma = 1;
  var e = nt();
  return sr = function(t, r) {
    r = r || {};
    var n = {}, i = ["url", "method", "params", "data"], u = ["headers", "auth", "proxy"], c = ["baseURL", "url", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "maxContentLength", "validateStatus", "maxRedirects", "httpAgent", "httpsAgent", "cancelToken", "socketPath"];
    e.forEach(i, function(g) {
      typeof r[g] < "u" && (n[g] = r[g]);
    }), e.forEach(u, function(g) {
      e.isObject(r[g]) ? n[g] = e.deepMerge(t[g], r[g]) : typeof r[g] < "u" ? n[g] = r[g] : e.isObject(t[g]) ? n[g] = e.deepMerge(t[g]) : typeof t[g] < "u" && (n[g] = t[g]);
    }), e.forEach(c, function(g) {
      typeof r[g] < "u" ? n[g] = r[g] : typeof t[g] < "u" && (n[g] = t[g]);
    });
    var f = i.concat(u).concat(c), b = Object.keys(r).filter(function(g) {
      return f.indexOf(g) === -1;
    });
    return e.forEach(b, function(g) {
      typeof r[g] < "u" ? n[g] = r[g] : typeof t[g] < "u" && (n[g] = t[g]);
    }), n;
  }, sr;
}
var ur, Da;
function gc() {
  if (Da) return ur;
  Da = 1;
  var e = nt(), t = vo(), r = ac(), n = mc(), i = ko();
  function u(c) {
    this.defaults = c, this.interceptors = {
      request: new r(),
      response: new r()
    };
  }
  return u.prototype.request = function(c) {
    typeof c == "string" ? (c = arguments[1] || {}, c.url = arguments[0]) : c = c || {}, c = i(this.defaults, c), c.method ? c.method = c.method.toLowerCase() : this.defaults.method ? c.method = this.defaults.method.toLowerCase() : c.method = "get";
    var f = [n, void 0], b = Promise.resolve(c);
    for (this.interceptors.request.forEach(function(g) {
      f.unshift(g.fulfilled, g.rejected);
    }), this.interceptors.response.forEach(function(g) {
      f.push(g.fulfilled, g.rejected);
    }); f.length; )
      b = b.then(f.shift(), f.shift());
    return b;
  }, u.prototype.getUri = function(c) {
    return c = i(this.defaults, c), t(c.url, c.params, c.paramsSerializer).replace(/^\?/, "");
  }, e.forEach(["delete", "get", "head", "options"], function(c) {
    u.prototype[c] = function(f, b) {
      return this.request(e.merge(b || {}, {
        method: c,
        url: f
      }));
    };
  }), e.forEach(["post", "put", "patch"], function(c) {
    u.prototype[c] = function(f, b, g) {
      return this.request(e.merge(g || {}, {
        method: c,
        url: f,
        data: b
      }));
    };
  }), ur = u, ur;
}
var cr, Ia;
function Oo() {
  if (Ia) return cr;
  Ia = 1;
  function e(t) {
    this.message = t;
  }
  return e.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, e.prototype.__CANCEL__ = !0, cr = e, cr;
}
var lr, Na;
function wc() {
  if (Na) return lr;
  Na = 1;
  var e = Oo();
  function t(r) {
    if (typeof r != "function")
      throw new TypeError("executor must be a function.");
    var n;
    this.promise = new Promise(function(u) {
      n = u;
    });
    var i = this;
    r(function(u) {
      i.reason || (i.reason = new e(u), n(i.reason));
    });
  }
  return t.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, t.source = function() {
    var r, n = new t(function(i) {
      r = i;
    });
    return {
      token: n,
      cancel: r
    };
  }, lr = t, lr;
}
var ja, _a;
function vc() {
  return _a || (_a = 1, ja = function(e) {
    return function(t) {
      return e.apply(null, t);
    };
  }), ja;
}
var Ra;
function bc() {
  if (Ra) return ne.exports;
  Ra = 1;
  var e = nt(), t = wo(), r = gc(), n = ko(), i = So();
  function u(f) {
    var b = new r(f), g = t(r.prototype.request, b);
    return e.extend(g, r.prototype, b), e.extend(g, b), g;
  }
  var c = u(i);
  return c.Axios = r, c.create = function(f) {
    return u(n(c.defaults, f));
  }, c.Cancel = Oo(), c.CancelToken = wc(), c.isCancel = bo(), c.all = function(f) {
    return Promise.all(f);
  }, c.spread = vc(), ne.exports = c, ne.exports.default = c, ne.exports;
}
var Ca, Fa;
function Ec() {
  return Fa || (Fa = 1, Ca = bc()), Ca;
}
var Sc = Ec();
const kc = /* @__PURE__ */ so(Sc);
class z {
  constructor({ url: t, data: r }) {
    return z.getData({ url: t, data: r });
  }
  static async getData({ url: t, data: r }) {
    try {
      const n = await kc.post(t, nc.stringify(r), {
        headers: {
          Accept: "*/*",
          "Content-type": "application/x-www-form-urlencoded"
        },
        withCredentials: !0
      });
      if (n.status === 200)
        return n.data.data;
      throw new Error(`Error code ${n.status}`);
    } catch (n) {
      throw new Error(`${n}
 ${t}
 ${JSON.stringify(r)}`);
    }
  }
}
const Oc = {
  apiGatewayUrl: "//api-gateway.test-01.travellata.ru"
};
class Tc {
  constructor(t) {
    yt(this, "apiGatewayTrackingPath");
    const { apiGatewayUrl: r } = t;
    if (!r)
      throw new Error("No apiGatewayUrl!");
    this.apiGatewayTrackingPath = `${r}/frontend/tracking/`;
  }
  setAnalytics(t) {
    return new z({
      url: this.apiGatewayTrackingPath + "analytics",
      data: t
    });
  }
  addHotelView(t) {
    return new z({
      url: this.apiGatewayTrackingPath + "hotelView",
      data: t
    });
  }
  trackCoreWebVitals(t) {
    return new z({
      url: this.apiGatewayTrackingPath + "coreWebVitals",
      data: t
    });
  }
  trackVisit(t) {
    return new z({
      url: this.apiGatewayTrackingPath + "visit",
      data: t
    });
  }
  trackCalendar(t) {
    return new z({
      url: this.apiGatewayTrackingPath + "calendar",
      data: t
    });
  }
  trackIntelligentSearch(t) {
    return new z({
      url: this.apiGatewayTrackingPath + "intelligentSearch",
      data: t
    });
  }
  trackSearchStart(t) {
    return new z({
      url: this.apiGatewayTrackingPath + "serpStartSearch",
      data: t
    });
  }
  trackEmptySearchStart(t) {
    return new z({
      url: this.apiGatewayTrackingPath + "serpStartEmptySearch",
      data: t
    });
  }
  trackSearch(t) {
    return new z({
      url: this.apiGatewayTrackingPath + "serpSearchResults",
      data: t
    });
  }
  trackSearchAgency(t) {
    return new z({
      url: this.apiGatewayTrackingPath + "agencySerpSearchResults",
      data: t
    });
  }
  trackSearchFilters(t) {
    return new z({
      url: this.apiGatewayTrackingPath + "serpSearchFilters",
      data: t
    });
  }
  trackSerpHotelPosition(t) {
    return new z({
      url: this.apiGatewayTrackingPath + "serpHotelPositions",
      data: t
    });
  }
  trackTourHunters(t) {
    return new z({
      url: this.apiGatewayTrackingPath + "serpTourHunters",
      data: t
    });
  }
  trackHotelPage(t) {
    return new z({
      url: this.apiGatewayTrackingPath + "hotelPageSearchResults",
      data: t
    });
  }
  trackAgencyHotelPage(t) {
    return new z({
      url: this.apiGatewayTrackingPath + "agencyHotelPageSearchResults",
      data: t
    });
  }
  trackHotelPageRoomCategories(t) {
    return new z({
      url: this.apiGatewayTrackingPath + "hotelPageRoomCategories",
      data: t
    });
  }
  trackTourPage(t) {
    return new z({
      url: this.apiGatewayTrackingPath + "tourPageActualizationResults",
      data: t
    });
  }
  trackAgencyTourPageSearchResults(t) {
    return new z({
      url: this.apiGatewayTrackingPath + "agencyTourPageActualizationResults",
      data: t
    });
  }
}
class xc {
  constructor(t = {}) {
    yt(this, "config"), yt(this, "api"), yt(this, "trClient"), yt(this, "customerUuid");
    const { config: r = {}, clientUuid: n } = t;
    this.config = Object.assign({}, Oc, r);
    const i = new Tc({ apiGatewayUrl: this.config.apiGatewayUrl });
    this.api = i, this.trClient = new Ft({ api: i, clientUuid: n });
  }
  getClientUuid() {
    return this.trClient.getClientUuid();
  }
  setCustomerUuid(t) {
    this.customerUuid = t;
  }
  getCustomerUuid() {
    return this.customerUuid || null;
  }
  track(t) {
    const { type: r, data: n } = t;
    if (r && n)
      switch (r) {
        case "addHotelView":
        case "trackSearch":
        case "trackSearchAgency":
        case "trackSearchStart":
        case "trackEmptySearchStart":
        case "trackSearchFilters":
        case "trackHotelPage":
        case "trackAgencyHotelPage":
        case "trackTourPage":
        case "trackAgencyTourPageSearchResults":
        case "trackVisit":
        case "trackCalendar":
        case "trackIntelligentSearch":
        case "trackXtravelTour":
        case "trackXtravelInterest":
        case "trackHotelPageRoomCategories":
        case "trackSerpHotelPosition":
        case "trackCoreWebVitals":
        case "trackTourHunters":
          this._process({ type: r, data: n });
          break;
        default:
          console.warn("Unknown action type");
      }
    else console.warn(r ? `No Data for action ${r}` : "No Action type");
  }
  _process({ type: t, data: r }) {
    try {
      this.api[t]({
        data: r,
        clientUuid: this.getClientUuid(),
        customerUuid: this.getCustomerUuid()
      });
    } catch (n) {
      throw new Error(`Fetch error: ${n}`);
    }
  }
}
class Pc extends Jt {
  constructor() {
    super(...arguments);
    N(this, "client", null);
    N(this, "url");
    N(this, "clientUuid");
  }
  init(r) {
    this.isStartedInit || (this.url = r.url, this.clientUuid = r.clientUuid, this.baseInit(r.timeoutMS));
  }
  install() {
    if (!this.url)
      throw new Lt("TrackerAnalyticsProvider requires a url parameter", {
        serviceName: V.TRACKER
      });
    try {
      this.client = new xc({
        config: {
          apiGatewayUrl: this.url
        },
        clientUuid: this.clientUuid || void 0
      });
    } catch (r) {
      throw new Lt("TrackerAnalyticsProvider initialization failed", {
        serviceName: V.TRACKER,
        cause: r
      });
    }
  }
  isInstalled() {
    return this.client !== null;
  }
  track(r) {
    this.enqueueOrExecute(() => this.client.track(r));
  }
  setCustomerUuid(r) {
    this.enqueueOrExecute(() => this.client.setCustomerUuid(r));
  }
}
class Ac extends Jt {
  constructor() {
    super(...arguments);
    N(this, "yandexWindowKey");
    N(this, "counterId");
    N(this, "ecommerceWindowKey");
  }
  init(r) {
    this.isStartedInit || (this.counterId = r.counterId, this.yandexWindowKey = r.windowKey || `yaCounter${r.counterId}`, this.ecommerceWindowKey = this.getEcommerceWindowKey(r.ecommerce), this.baseInit(r.timeoutMS));
  }
  getEcommerceWindowKey(r) {
    return r ? r === !0 ? Rc : r : "";
  }
  install() {
    if (!this.counterId)
      throw new Lt("MetrikaAnalyticsProvider requires a counterId parameter", {
        serviceName: V.METRIKA
      });
    this.ecommerceWindowKey && !window[this.ecommerceWindowKey] && (window[this.ecommerceWindowKey] = []), window.yandex_metrika_callbacks = window.yandex_metrika_callbacks || [], window.yandex_metrika_callbacks.push(() => {
      !window.Ya || !window.Ya.Metrika || (window[this.yandexWindowKey] = new window.Ya.Metrika({
        id: this.counterId,
        clickmap: !0,
        trackLinks: !0,
        accurateTrackBounce: !0,
        trackHash: !0,
        ecommerce: this.ecommerceWindowKey,
        triggerEvent: !0
      }));
    }), wr(_c);
  }
  isInstalled() {
    return !!window[this.yandexWindowKey];
  }
  get metrika() {
    return window[this.yandexWindowKey];
  }
  visitParams(r) {
    this.enqueueOrExecute(() => this.metrika.params(r));
  }
  userParams(r) {
    this.enqueueOrExecute(() => this.metrika.userParams(r));
  }
  hit(r) {
    this.enqueueOrExecute(() => this.metrika.hit(r));
  }
  reachGoal(r, n) {
    this.enqueueOrExecute(() => this.metrika.reachGoal(r, n));
  }
  ecommerce(r) {
    this.enqueueOrExecute(() => window[this.ecommerceWindowKey].push(r));
  }
}
//! TrackJS JavaScript error monitoring agent.
//! COPYRIGHT (c) 2023 ALL RIGHTS RESERVED
//! See License at https://trackjs.com/terms/
var Ht = function(e, t, r) {
  "use awesome";
  var n = function(a, s) {
    this.config = a, this.onError = s, a.enabled && this.watch();
  };
  n.prototype = { watch: function() {
    d.forEach(["EventTarget", "Node", "XMLHttpRequest"], function(a) {
      d.has(e, a + ".prototype.addEventListener") && d.hasOwn(e[a].prototype, "addEventListener") && this.wrapEventTarget(e[a].prototype);
    }, this), this.wrapTimer("setTimeout"), this.wrapTimer("setInterval");
  }, wrap: function(a) {
    function s() {
      try {
        return a.apply(this, arguments);
      } catch (m) {
        throw o.onError("catch", m, { bindTime: l, bindStack: h }), d.wrapError(m);
      }
    }
    var o = this;
    try {
      if (!d.isFunction(a) || d.hasOwn(a, "__trackjs__")) return a;
      if (d.hasOwn(a, "__trackjs_state__")) return a.__trackjs_state__;
    } catch {
      return a;
    }
    var l, h;
    if (o.config.bindStack) try {
      throw Error();
    } catch (m) {
      h = m.stack, l = d.isoNow();
    }
    for (var w in a) d.hasOwn(a, w) && (s[w] = a[w]);
    return s.prototype = a.prototype, s.__trackjs__ = !0, a.__trackjs_state__ = s;
  }, wrapEventTarget: function(a) {
    var s = this;
    d.has(a, "addEventListener.call") && d.has(a, "removeEventListener.call") && (d.patch(
      a,
      "addEventListener",
      function(o) {
        return function(l, h, w, m) {
          try {
            d.has(h, "handleEvent") && (h.handleEvent = s.wrap(h.handleEvent));
          } catch {
          }
          return o.call(this, l, s.wrap(h), w, m);
        };
      }
    ), d.patch(a, "removeEventListener", function(o) {
      return function(l, h, w, m) {
        try {
          h = h && (h.__trackjs_state__ || h);
        } catch {
        }
        return o.call(this, l, h, w, m);
      };
    }));
  }, wrapTimer: function(a) {
    var s = this;
    d.patch(e, a, function(o) {
      return function(l, h) {
        var w = Array.prototype.slice.call(arguments), m = w[0];
        return d.isFunction(m) && (w[0] = s.wrap(m)), d.has(o, "apply") ? o.apply(this, w) : o(w[0], w[1]);
      };
    });
  } };
  var i = function(a) {
    this.initCurrent(a) || console.warn("[TrackJS] invalid config");
  };
  i.prototype = { current: {}, initOnly: { application: !0, cookie: !0, enabled: !0, token: !0, callback: { enabled: !0 }, console: { enabled: !0 }, navigation: { enabled: !0 }, network: { enabled: !0, fetch: !0 }, visitor: { enabled: !0 }, window: { enabled: !0, promise: !0 } }, defaults: {
    application: "",
    cookie: !1,
    dedupe: !0,
    dependencies: !0,
    enabled: !0,
    forwardingDomain: "",
    errorURL: "https://capture.trackjs.com/capture",
    errorNoSSLURL: "http://capture.trackjs.com/capture",
    faultURL: "https://usage.trackjs.com/fault.gif",
    usageURL: "https://usage.trackjs.com/usage.gif",
    onError: function() {
      return !0;
    },
    serialize: function(a) {
      function s(h) {
        var w = "<" + h.tagName.toLowerCase();
        h = h.attributes || [];
        for (var m = 0; m < h.length; m++) w += " " + h[m].name + '="' + h[m].value + '"';
        return w + ">";
      }
      if (a === "") return "Empty String";
      if (a === r) return "undefined";
      if (d.isString(a) || d.isNumber(a) || d.isBoolean(a) || d.isFunction(a)) return "" + a;
      if (d.isElement(a)) return s(a);
      if (typeof a == "symbol") return Symbol.prototype.toString.call(a);
      var o;
      try {
        o = JSON.stringify(a, function(h, w) {
          return w === r ? "undefined" : d.isNumber(w) && isNaN(w) ? "NaN" : d.isError(w) ? { name: w.name, message: w.message, stack: w.stack } : d.isElement(w) ? s(w) : w;
        });
      } catch {
        o = "";
        for (var l in a) if (a.hasOwnProperty(l)) try {
          o += ',"' + l + '":"' + a[l] + '"';
        } catch {
        }
        o = o ? "{" + o.replace(",", "") + "}" : "Unserializable Object";
      }
      return o.replace(/"undefined"/g, "undefined").replace(/"NaN"/g, "NaN");
    },
    sessionId: "",
    token: "",
    userId: "",
    version: "",
    callback: { enabled: !0, bindStack: !1 },
    console: {
      enabled: !0,
      display: !0,
      error: !0,
      warn: !1,
      watch: ["log", "debug", "info", "warn", "error"]
    },
    navigation: { enabled: !0 },
    network: { enabled: !0, error: !0, fetch: !0 },
    visitor: { enabled: !0 },
    window: { enabled: !0, promise: !0 }
  }, initCurrent: function(a) {
    return this.removeEmpty(a), this.validate(a, this.defaults, "[TrackJS] config", {}) ? (this.current = d.defaultsDeep({}, a, this.defaults), !0) : (this.current = d.defaultsDeep({}, this.defaults), !1);
  }, setCurrent: function(a) {
    return this.validate(a, this.defaults, "[TrackJS] config", this.initOnly) ? (this.current = d.defaultsDeep(
      {},
      a,
      this.current
    ), !0) : !1;
  }, removeEmpty: function(a) {
    for (var s in a) a.hasOwnProperty(s) && a[s] === r && delete a[s];
  }, validate: function(a, s, o, l) {
    var h = !0;
    o = o || "", l = l || {};
    for (var w in a) if (a.hasOwnProperty(w)) if (s.hasOwnProperty(w)) {
      var m = typeof s[w];
      m !== typeof a[w] ? (console.warn(o + "." + w + ": property must be type " + m + "."), h = !1) : Object.prototype.toString.call(a[w]) !== "[object Array]" || this.validateArray(a[w], s[w], o + "." + w) ? Object.prototype.toString.call(a[w]) === "[object Object]" ? h = this.validate(a[w], s[w], o + "." + w, l[w]) : l.hasOwnProperty(w) && (console.warn(o + "." + w + ": property cannot be set after load."), h = !1) : h = !1;
    } else console.warn(o + "." + w + ": property not supported."), h = !1;
    return h;
  }, validateArray: function(a, s, o) {
    var l = !0;
    o = o || "";
    for (var h = 0; h < a.length; h++) d.contains(s, a[h]) || (console.warn(o + "[" + h + "]: invalid value: " + a[h] + "."), l = !1);
    return l;
  } };
  var u = function(a, s, o, l, h, w, m) {
    this.util = a, this.log = s, this.onError = o, this.onFault = l, this.serialize = h, m.enabled && (w.console = this.wrapConsoleObject(w.console, m));
  };
  u.prototype = { wrapConsoleObject: function(a, s) {
    a = a || {};
    var o = a.log || function() {
    }, l = this, h;
    for (h = 0; h < s.watch.length; h++) (function(w) {
      var m = a[w] || o;
      a[w] = function() {
        try {
          var O = Array.prototype.slice.call(arguments);
          if (l.log.add("c", { timestamp: l.util.isoNow(), severity: w, message: l.serialize(O.length === 1 ? O[0] : O) }), s[w]) if (d.isError(O[0]) && O.length === 1) l.onError("console", O[0]);
          else try {
            throw Error(l.serialize(O.length === 1 ? O[0] : O));
          } catch (P) {
            l.onError("console", P);
          }
          s.display && (l.util.hasFunction(m, "apply") ? m.apply(a, O) : m(O[0]));
        } catch (P) {
          l.onFault(P);
        }
      };
    })(s.watch[h]);
    return a;
  }, report: function() {
    return this.log.all("c");
  } };
  var c = function(a, s, o, l, h) {
    this.config = a, this.util = s, this.log = o, this.window = l, this.document = h, this.correlationId = this.token = null, this.initialize();
  };
  c.prototype = { initialize: function() {
    this.token = this.getCustomerToken(), this.correlationId = this.getCorrelationId();
  }, getCustomerToken: function() {
    if (this.config.current.token) return this.config.current.token;
    var a = this.document.getElementsByTagName("script");
    return a[a.length - 1].getAttribute("data-token");
  }, getCorrelationId: function() {
    var a;
    if (!this.config.current.cookie) return this.util.uuid();
    try {
      a = this.document.cookie.replace(/(?:(?:^|.*;\s*)TrackJS\s*\=\s*([^;]*).*$)|^.*$/, "$1"), a || (a = this.util.uuid(), this.document.cookie = "TrackJS=" + a + "; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/");
    } catch {
      a = this.util.uuid();
    }
    return a;
  }, report: function() {
    return {
      application: this.config.current.application,
      correlationId: this.correlationId,
      sessionId: this.config.current.sessionId,
      token: this.token,
      userId: this.config.current.userId,
      version: this.config.current.version
    };
  } };
  var f = function(a) {
    this.config = a, this.loadedOn = (/* @__PURE__ */ new Date()).getTime(), this.originalUrl = d.getLocation(), this.referrer = d.isBrowser ? t.referrer : "";
  };
  f.prototype = { discoverDependencies: function() {
    var a = { TrackJS: "3.10.4" };
    e.jQuery && e.jQuery.fn && e.jQuery.fn.jquery && (a.jQuery = e.jQuery.fn.jquery), e.jQuery && e.jQuery.ui && e.jQuery.ui.version && (a.jQueryUI = e.jQuery.ui.version), e.angular && e.angular.version && e.angular.version.full && (a.angular = e.angular.version.full);
    for (var s in e) if (s !== "_trackJs" && s !== "_trackJS" && s !== "_trackjs" && s !== "webkitStorageInfo" && s !== "webkitIndexedDB" && s !== "top" && s !== "parent" && s !== "frameElement") try {
      if (e[s]) {
        var o = e[s].version || e[s].Version || e[s].VERSION;
        typeof o == "string" && (a[s] = o);
      }
    } catch {
    }
    return a.TrackJS && a.trackJs && delete a.trackJs, a;
  }, report: function() {
    return {
      age: (/* @__PURE__ */ new Date()).getTime() - this.loadedOn,
      dependencies: this.config.current.dependencies ? this.discoverDependencies() : { trackJs: "3.10.4" },
      originalUrl: this.originalUrl,
      referrer: this.referrer,
      userAgent: e.navigator.userAgent,
      viewportHeight: d.isBrowser ? e.document.documentElement.clientHeight : 0,
      viewportWidth: d.isBrowser ? e.document.documentElement.clientWidth : 0
    };
  } };
  var b = function(a) {
    this.util = a, this.appender = [], this.maxLength = 30;
  };
  b.prototype = { all: function(a) {
    var s = [], o, l;
    for (l = 0; l < this.appender.length; l++) (o = this.appender[l]) && o.category === a && s.push(o.value);
    return s;
  }, clear: function() {
    this.appender.length = 0;
  }, truncate: function() {
    this.appender.length > this.maxLength && (this.appender = this.appender.slice(Math.max(this.appender.length - this.maxLength, 0)));
  }, add: function(a, s) {
    var o = this.util.uuid();
    return this.appender.push({ key: o, category: a, value: s }), this.truncate(), o;
  }, get: function(a, s) {
    var o, l;
    for (l = 0; l < this.appender.length; l++) if (o = this.appender[l], o.category === a && o.key === s) return o.value;
    return !1;
  } };
  var g = function(a) {
    var s = {};
    return { addMetadata: function(o, l) {
      s[o] = l;
    }, removeMetadata: function(o) {
      delete s[o];
    }, report: function() {
      var o = [], l;
      for (l in s) s.hasOwnProperty(l) && o.push({
        key: l,
        value: a(s[l])
      });
      return o;
    }, store: s };
  }, y = function(a, s) {
    this.log = a, this.options = s, s.enabled && this.watch();
  };
  y.prototype = { isCompatible: function(a) {
    return a = a || e, !d.has(a, "chrome.app.runtime") && d.has(a, "addEventListener") && d.has(a, "history.pushState");
  }, record: function(a, s, o) {
    this.log.add("h", { type: a, from: d.truncate(s, 250), to: d.truncate(o, 250), on: d.isoNow() });
  }, report: function() {
    return this.log.all("h");
  }, watch: function() {
    if (this.isCompatible()) {
      var a = this, s = d.getLocationURL().relative;
      e.addEventListener(
        "popstate",
        function() {
          var o = d.getLocationURL().relative;
          a.record("popState", s, o), s = o;
        },
        !0
      ), d.forEach(["pushState", "replaceState"], function(o) {
        d.patch(history, o, function(l) {
          return function() {
            s = d.getLocationURL().relative;
            var h = l.apply(this, arguments), w = d.getLocationURL().relative;
            return a.record(o, s, w), s = w, h;
          };
        });
      });
    }
  } };
  var E = function(a, s, o, l, h, w) {
    this.util = a, this.log = s, this.onError = o, this.onFault = l, this.window = h, this.options = w, w.enabled && this.initialize(h);
  };
  E.prototype = { initialize: function(a) {
    a.XMLHttpRequest && this.util.hasFunction(
      a.XMLHttpRequest.prototype.open,
      "apply"
    ) && this.watchNetworkObject(a.XMLHttpRequest), a.XDomainRequest && this.util.hasFunction(a.XDomainRequest.prototype.open, "apply") && this.watchNetworkObject(a.XDomainRequest), this.options.fetch && d.isWrappableFunction(a.fetch) && this.watchFetch();
  }, escapeUrl: function(a) {
    return ("" + a).replace(/ /gi, "%20").replace(/\t/gi, "%09");
  }, watchFetch: function() {
    var a = this, s = this.log, o = this.options, l = this.onError;
    d.patch(e, "fetch", function(h) {
      return function(w, m) {
        if (m && m.__trackjs__) return h.apply(e, arguments);
        var O;
        try {
          throw Error();
        } catch (M) {
          O = M.stack;
        }
        var D = w instanceof Request ? w.url : w, P = w instanceof Request ? w.method : (m || {}).method || "GET", D = a.escapeUrl(D), A = h.apply(e, arguments);
        return A.__trackjs_state__ = s.add("n", { type: "fetch", startedOn: d.isoNow(), method: P, url: d.truncate(D, 2e3) }), A.then(function(M) {
          var W = s.get("n", A.__trackjs_state__);
          if (W) {
            d.defaults(W, { completedOn: d.isoNow(), statusCode: M.status, statusText: M.statusText });
            var $ = M.headers.get("trackjs-correlation-id");
            $ && (W.requestCorrelationId = $), o.error && 400 <= M.status && (W = Error(W.statusCode + " : " + W.method + " " + W.url), W.stack = O, l("ajax", W));
          }
          return M;
        }).catch(function(M) {
          M = M || {};
          var W = s.get("n", A.__trackjs_state__);
          throw W && (d.defaults(W, { completedOn: d.isoNow(), statusCode: 0, statusText: M.toString() }), o.error && (l("ajax", { name: M.name, message: (M.message || "Failed") + ": " + W.method + " " + W.url, stack: M.stack || O }), M.__trackjs_state__ = !0)), M;
        });
      };
    });
  }, watchNetworkObject: function(a) {
    var s = this, o = a.prototype.open, l = a.prototype.send;
    return a.prototype.open = function(h, w) {
      var m = (w || "").toString();
      return 0 > m.indexOf("localhost:0") && (m = s.escapeUrl(m), this._trackJs = { method: h, url: m }), o.apply(this, arguments);
    }, a.prototype.send = function() {
      if (!this._trackJs) try {
        return l.apply(this, arguments);
      } catch (h) {
        s.onError("ajax", h);
        return;
      }
      try {
        this._trackJs.logId = s.log.add("n", { type: "xhr", startedOn: s.util.isoNow(), method: this._trackJs.method, url: d.truncate(this._trackJs.url, 2e3) }), s.listenForNetworkComplete(this);
      } catch (h) {
        s.onFault(h);
      }
      return l.apply(this, arguments);
    }, a;
  }, listenForNetworkComplete: function(a) {
    var s = this;
    s.window.ProgressEvent && a.addEventListener && a.addEventListener("readystatechange", function() {
      a.readyState === 4 && s.finalizeNetworkEvent(a);
    }, !0), a.addEventListener ? a.addEventListener("load", function() {
      s.finalizeNetworkEvent(a), s.checkNetworkFault(a);
    }, !0) : setTimeout(function() {
      try {
        var o = a.onload;
        a.onload = function() {
          s.finalizeNetworkEvent(a), s.checkNetworkFault(a), typeof o == "function" && s.util.hasFunction(o, "apply") && o.apply(a, arguments);
        };
        var l = a.onerror;
        a.onerror = function() {
          s.finalizeNetworkEvent(a), s.checkNetworkFault(a), typeof oldOnError == "function" && l.apply(a, arguments);
        };
      } catch (h) {
        s.onFault(h);
      }
    }, 0);
  }, finalizeNetworkEvent: function(a) {
    if (a._trackJs) {
      var s = this.log.get("n", a._trackJs.logId);
      s && (s.completedOn = this.util.isoNow(), a.getAllResponseHeaders && a.getResponseHeader && 0 <= (a.getAllResponseHeaders() || "").toLowerCase().indexOf("trackjs-correlation-id") && (s.requestCorrelationId = a.getResponseHeader("trackjs-correlation-id")), s.statusCode = a.status == 1223 ? 204 : a.status, s.statusText = a.status == 1223 ? "No Content" : a.statusText);
    }
  }, checkNetworkFault: function(a) {
    if (this.options.error && 400 <= a.status && a.status != 1223) {
      var s = a._trackJs || {};
      this.onError("ajax", a.status + " : " + s.method + " " + s.url);
    }
  }, report: function() {
    return this.log.all("n");
  } };
  var p = function(a, s) {
    this.util = a, this.config = s, this.disabled = !1, this.throttleStats = { attemptCount: 0, throttledCount: 0, lastAttempt: (/* @__PURE__ */ new Date()).getTime() }, e.JSON && e.JSON.stringify || (this.disabled = !0);
  };
  p.prototype = { errorEndpoint: function(a) {
    var s = this.config.current, o = s.errorURL;
    return d.isBrowser && !d.testCrossdomainXhr() && e.location.protocol.indexOf("https") === -1 ? o = s.errorNoSSLURL : s.forwardingDomain && (o = "https://" + s.forwardingDomain + "/capture"), o + "?token=" + a + "&v=3.10.4";
  }, usageEndpoint: function(a) {
    var s = this.config.current, o = s.usageURL;
    return s.forwardingDomain && (o = "https://" + s.forwardingDomain + "/usage.gif"), this.appendObjectAsQuery(a, o);
  }, trackerFaultEndpoint: function(a) {
    var s = (this.config || {}).current || i.prototype.defaults, o = s.faultURL;
    return s.forwardingDomain && (o = "https://" + s.forwardingDomain + "/fault.gif"), this.appendObjectAsQuery(a, o);
  }, appendObjectAsQuery: function(a, s) {
    s += "?";
    for (var o in a) a.hasOwnProperty(o) && (s += encodeURIComponent(o) + "=" + encodeURIComponent(a[o]) + "&");
    return s;
  }, getCORSRequest: function(a, s) {
    var o;
    return this.util.testCrossdomainXhr() ? (o = new e.XMLHttpRequest(), o.open(a, s), o.setRequestHeader("Content-Type", "text/plain")) : typeof e.XDomainRequest < "u" ? (o = new e.XDomainRequest(), o.open(a, s)) : o = null, o;
  }, sendTrackerFault: function(a) {
    this.throttle(a) || (d.isBrowser ? t.createElement("img").src = this.trackerFaultEndpoint(a) : fetch(this.trackerFaultEndpoint(a), { mode: "no-cors", __trackjs__: !0 }));
  }, sendUsage: function(a) {
    d.isBrowser ? t.createElement("img").src = this.usageEndpoint(a) : fetch(this.usageEndpoint(a), { mode: "no-cors", __trackjs__: !0 });
  }, sendError: function(a, s) {
    var o = this;
    if (!this.disabled && !this.throttle(a)) try {
      if (d.isBrowser) {
        var l = this.getCORSRequest("POST", this.errorEndpoint(s));
        l.onreadystatechange = function() {
          l.readyState !== 4 || d.contains(
            [200, 202],
            l.status
          ) || (o.disabled = !0);
        }, l._trackJs = r, l.send(e.JSON.stringify(a));
      } else if (d.isWorker) {
        var h = { method: "POST", mode: "cors", body: e.JSON.stringify(a), __trackjs__: 1 };
        fetch(this.errorEndpoint(s), h).then(function(w) {
          w.ok || (o.disabled = !0);
        }).catch(function(w) {
          o.disabled = !0;
        });
      }
    } catch (w) {
      throw this.disabled = !0, w;
    }
  }, throttle: function(a) {
    var s = (/* @__PURE__ */ new Date()).getTime();
    if (this.throttleStats.attemptCount++, this.throttleStats.lastAttempt + 1e3 >= s) {
      if (this.throttleStats.lastAttempt = s, 10 < this.throttleStats.attemptCount) return this.throttleStats.throttledCount++, !0;
    } else a.throttled = this.throttleStats.throttledCount, this.throttleStats.attemptCount = 0, this.throttleStats.lastAttempt = s, this.throttleStats.throttledCount = 0;
    return !1;
  } };
  var d = function() {
    function a(o, l, h, w) {
      return h = h || !1, w = w || 0, d.forEach(l, function(m) {
        d.forEach(d.keys(m), function(O) {
          m[O] === null || m[O] === r ? o[O] = m[O] : h && 10 > w && s(m[O]) === "[object Object]" ? (o[O] = o[O] || {}, a(o[O], [m[O]], h, w + 1)) : o.hasOwnProperty(O) || (o[O] = m[O]);
        });
      }), o;
    }
    function s(o) {
      return Object.prototype.toString.call(o);
    }
    return {
      isBrowser: typeof e < "u" && typeof e.document < "u",
      isWorker: typeof self == "object" && self.constructor && 0 <= (self.constructor.name || "").indexOf("WorkerGlobalScope"),
      isNode: typeof process < "u" && process.versions != null && process.versions.node != null,
      addEventListenerSafe: function(o, l, h, w) {
        o.addEventListener ? o.addEventListener(l, h, w) : o.attachEvent && o.attachEvent("on" + l, h);
      },
      afterDocumentLoad: function(o) {
        if (d.isWorker) d.defer(o);
        else {
          var l = !1;
          t.readyState === "complete" ? d.defer(o) : (d.addEventListenerSafe(
            t,
            "readystatechange",
            function() {
              t.readyState !== "complete" || l || (d.defer(o), l = !0);
            }
          ), setTimeout(function() {
            l || (d.defer(o), l = !0);
          }, 1e4));
        }
      },
      bind: function(o, l) {
        return function() {
          return o.apply(l, Array.prototype.slice.call(arguments));
        };
      },
      contains: function(o, l) {
        return 0 <= o.indexOf(l);
      },
      defaults: function(o) {
        return a(o, Array.prototype.slice.call(arguments, 1), !1);
      },
      defaultsDeep: function(o) {
        return a(o, Array.prototype.slice.call(arguments, 1), !0);
      },
      defer: function(o, l) {
        setTimeout(function() {
          o.apply(l);
        });
      },
      forEach: function(o, l, h) {
        if (d.isArray(o)) {
          if (o.forEach) return o.forEach(
            l,
            h
          );
          for (var w = 0; w < o.length; ) l.call(h, o[w], w, o), w++;
        }
      },
      getLocation: function() {
        return e.location.toString().replace(/ /g, "%20");
      },
      getLocationURL: function() {
        return d.parseURL(d.getLocation());
      },
      has: function(o, l) {
        try {
          for (var h = l.split("."), w = o, m = 0; m < h.length; m++) if (w[h[m]]) w = w[h[m]];
          else return !1;
          return !0;
        } catch {
          return !1;
        }
      },
      hasFunction: function(o, l) {
        try {
          return !!o[l];
        } catch {
          return !1;
        }
      },
      hasOwn: function(o, l) {
        return Object.prototype.hasOwnProperty.call(o, l);
      },
      isArray: function(o) {
        return s(o) === "[object Array]";
      },
      isBoolean: function(o) {
        return typeof o == "boolean" || d.isObject(o) && s(o) === "[object Boolean]";
      },
      isBrowserIE: function(o) {
        o = o || e.navigator.userAgent;
        var l = o.match(/Trident\/([\d.]+)/);
        return l && l[1] === "7.0" ? 11 : (o = o.match(/MSIE ([\d.]+)/)) ? parseInt(o[1], 10) : !1;
      },
      isBrowserSupported: function() {
        var o = this.isBrowserIE();
        return !o || 8 <= o;
      },
      isError: function(o) {
        if (!d.isObject(o)) return !1;
        var l = s(o);
        return l === "[object Error]" || l === "[object DOMException]" || d.isString(o.name) && d.isString(o.message);
      },
      isElement: function(o) {
        return d.isObject(o) && o.nodeType === 1;
      },
      isFunction: function(o) {
        return !(!o || typeof o != "function");
      },
      isNumber: function(o) {
        return typeof o == "number" || d.isObject(o) && s(o) === "[object Number]";
      },
      isObject: function(o) {
        return !(!o || typeof o != "object");
      },
      isString: function(o) {
        return typeof o == "string" || !d.isArray(o) && d.isObject(o) && s(o) === "[object String]";
      },
      isWrappableFunction: function(o) {
        return this.isFunction(o) && this.hasFunction(o, "apply");
      },
      isoNow: function() {
        var o = /* @__PURE__ */ new Date();
        return o.toISOString ? o.toISOString() : o.getUTCFullYear() + "-" + this.pad(o.getUTCMonth() + 1) + "-" + this.pad(o.getUTCDate()) + "T" + this.pad(o.getUTCHours()) + ":" + this.pad(o.getUTCMinutes()) + ":" + this.pad(o.getUTCSeconds()) + "." + String((o.getUTCMilliseconds() / 1e3).toFixed(3)).slice(2, 5) + "Z";
      },
      keys: function(o) {
        if (!d.isObject(o)) return [];
        var l = [], h;
        for (h in o) o.hasOwnProperty(h) && l.push(h);
        return l;
      },
      noop: function() {
      },
      pad: function(o) {
        return o = String(o), o.length === 1 && (o = "0" + o), o;
      },
      parseURL: function(o) {
        var l = o.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
        return l ? (l = { protocol: l[2], host: l[4], path: l[5], query: l[6], hash: l[8] }, l.origin = (l.protocol || "") + "://" + (l.host || ""), l.relative = (l.path || "") + (l.query || "") + (l.hash || ""), l.href = o, l) : {};
      },
      patch: function(o, l, h) {
        o[l] = h(o[l] || d.noop);
      },
      testCrossdomainXhr: function() {
        return d.isBrowser && "withCredentials" in new XMLHttpRequest();
      },
      truncate: function(o, l) {
        if (o = "" + o, o.length <= l) return o;
        var h = o.length - l;
        return o.substr(0, l) + "...{" + h + "}";
      },
      tryGet: function(o, l) {
        try {
          return o[l];
        } catch {
        }
      },
      uuid: function() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function(o) {
            var l = 16 * Math.random() | 0;
            return (o == "x" ? l : l & 3 | 8).toString(16);
          }
        );
      },
      wrapError: function(o) {
        var l = o || Object.prototype.toString.call(o);
        if (l && l.innerError) return o;
        var h = Error("TrackJS Caught: " + (l.message || l));
        return h.description = "TrackJS Caught: " + l.description, h.file = l.file, h.line = l.line || l.lineNumber, h.column = l.column || l.columnNumber, h.stack = l.stack, h.innerError = o, h;
      }
    };
  }(), x = function(a, s, o, l, h, w) {
    this.util = a, this.log = s, this.onError = o, this.onFault = l, this.options = w, this.document = h, a.isBrowser && w.enabled && this.initialize(h);
  };
  x.prototype = { initialize: function(a) {
    var s = this.util.bind(this.onDocumentClicked, this), o = this.util.bind(this.onInputChanged, this);
    a.addEventListener ? (a.addEventListener("click", s, !0), a.addEventListener("blur", o, !0)) : a.attachEvent && (a.attachEvent("onclick", s), a.attachEvent("onfocusout", o));
  }, onDocumentClicked: function(a) {
    try {
      var s = this.getElementFromEvent(a);
      s && s.tagName && (this.isDescribedElement(s, "a") || this.isDescribedElement(s, "button") || this.isDescribedElement(
        s,
        "input",
        ["button", "submit"]
      ) ? this.writeVisitorEvent(s, "click") : this.isDescribedElement(s, "input", ["checkbox", "radio"]) && this.writeVisitorEvent(s, "input", s.value, s.checked));
    } catch (o) {
      this.onFault(o);
    }
  }, onInputChanged: function(a) {
    try {
      var s = this.getElementFromEvent(a);
      s && s.tagName && (this.isDescribedElement(s, "textarea") ? this.writeVisitorEvent(s, "input", s.value) : this.isDescribedElement(s, "select") && s.options && s.options.length ? this.onSelectInputChanged(s) : this.isDescribedElement(s, "input") && !this.isDescribedElement(
        s,
        "input",
        ["button", "submit", "hidden", "checkbox", "radio"]
      ) && this.writeVisitorEvent(s, "input", s.value));
    } catch (o) {
      this.onFault(o);
    }
  }, onSelectInputChanged: function(a) {
    if (a.multiple) for (var s = 0; s < a.options.length; s++) a.options[s].selected && this.writeVisitorEvent(a, "input", a.options[s].value);
    else 0 <= a.selectedIndex && a.options[a.selectedIndex] && this.writeVisitorEvent(a, "input", a.options[a.selectedIndex].value);
  }, writeVisitorEvent: function(a, s, o, l) {
    this.getElementType(a) === "password" && (o = r);
    var h = this.getElementAttributes(a);
    a.innerText && (h.__trackjs_element_text = this.util.truncate(a.innerText, 500)), this.log.add("v", { timestamp: this.util.isoNow(), action: s, element: { tag: a.tagName.toLowerCase(), attributes: h, value: this.getMetaValue(o, l) } });
  }, getElementFromEvent: function(a) {
    return a.target || t.elementFromPoint(a.clientX, a.clientY);
  }, isDescribedElement: function(a, s, o) {
    if (a.tagName.toLowerCase() !== s.toLowerCase()) return !1;
    if (!o) return !0;
    for (a = this.getElementType(a), s = 0; s < o.length; s++) if (o[s] === a) return !0;
    return !1;
  }, getElementType: function(a) {
    return (a.getAttribute("type") || "").toLowerCase();
  }, getElementAttributes: function(a) {
    for (var s = {}, o = Math.min(a.attributes.length, 10), l = 0; l < o; l++) {
      var h = a.attributes[l];
      d.contains(["data-value", "value"], h.name.toLowerCase()) || (s[h.name] = d.truncate(h.value, 100));
    }
    return s;
  }, getMetaValue: function(a, s) {
    return a === r ? r : { length: a.length, pattern: this.matchInputPattern(a), checked: s };
  }, matchInputPattern: function(a) {
    return a === "" ? "empty" : /^[a-z0-9!#$%&'*+=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(a) ? "email" : /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/.test(a) || /^(\d{4}[\/\-](0?[1-9]|1[012])[\/\-]0?[1-9]|[12][0-9]|3[01])$/.test(a) ? "date" : /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/.test(a) ? "usphone" : /^\s*$/.test(a) ? "whitespace" : /^\d*$/.test(a) ? "numeric" : /^[a-zA-Z]*$/.test(a) ? "alpha" : /^[a-zA-Z0-9]*$/.test(a) ? "alphanumeric" : "characters";
  }, report: function() {
    return this.log.all("v");
  } };
  var k = function(a, s, o, l, h) {
    this.onError = a, this.onFault = s, this.serialize = o, h.enabled && this.watchWindowErrors(l), h.promise && this.watchPromiseErrors(l);
  };
  k.prototype = { watchPromiseErrors: function(a) {
    var s = this;
    a.addEventListener ? a.addEventListener("unhandledrejection", function(o) {
      try {
        o = o || {};
        var l = o.detail ? d.tryGet(o.detail, "reason") : d.tryGet(o, "reason");
        if (l !== r && l !== null && !l.__trackjs_state__) {
          if (!d.isError(l)) try {
            throw Error(s.serialize(l));
          } catch (h) {
            l = h;
          }
          s.onError("promise", l);
        }
      } catch (h) {
        s.onFault(h);
      }
    }) : d.patch(a, "onunhandledrejection", function(o) {
      return function(l) {
        s.onError("promise", l), o.apply(this, arguments);
      };
    });
  }, watchWindowErrors: function(a) {
    var s = this;
    d.patch(a, "onerror", function(o) {
      return function(l, h, w, m, O) {
        try {
          if (d.isError(O)) {
            s.onError("window", O), o.apply(this, arguments);
            return;
          }
          O = O || {};
          var P = { message: O.message || s.serialize(l), name: O.name || "Error", line: O.line || parseInt(w, 10) || null, column: O.column || parseInt(m, 10) || null, stack: O.stack || null };
          Object.prototype.toString.call(l) !== "[object Event]" || h ? P.file = O.file || s.serialize(h) : P.file = (l.target || {}).src, s.onError("window", P);
        } catch (D) {
          s.onFault(D);
        }
        o.apply(this, arguments);
      };
    });
  } };
  var T = function() {
    this.hasInstalled = !1, this.hasEnabled = !0, this.window = e, this.document = t, this.util = d, this.install = d.bind(this.install, this), this.onError = d.bind(this.onError, this), this.onFault = d.bind(this.onFault, this), this.serialize = d.bind(this.serialize, this), this.log = new b(d), this.metadata = new g(this.serialize);
    var a = e && (e._trackJs || e._trackJS || e._trackjs);
    a && this.install(a);
  };
  return T.prototype = {
    install: function(a) {
      try {
        if (d.isNode) return this.warn("monitoring disabled in node"), !1;
        if (!d.has(a, "token")) return this.warn("missing token"), !1;
        if (this.hasInstalled) return this.warn("already installed"), !1;
        if (this.config = new i(a), this.transmitter = new p(this.util, this.config), this.environment = new f(this.config), this.customer = new c(this.config, this.util, this.log, this.window, this.document), !this.config.current.enabled) return this.hasEnabled = !1;
        if (this.windowConsoleWatcher = new u(this.util, this.log, this.onError, this.onFault, this.serialize, this.window, this.config.current.console), !this.util.isBrowserSupported()) return !1;
        this.callbackWatcher = new n(this.config.current.callback, this.onError, this.onFault), this.visitorWatcher = new x(this.util, this.log, this.onError, this.onFault, this.document, this.config.current.visitor), this.navigationWatcher = new y(this.log, this.config.current.navigation), this.networkWatcher = new E(
          this.util,
          this.log,
          this.onError,
          this.onFault,
          this.window,
          this.config.current.network
        ), this.windowWatcher = new k(this.onError, this.onFault, this.serialize, this.window, this.config.current.window);
        var s = this;
        return d.afterDocumentLoad(function() {
          s.transmitter.sendUsage({ token: s.customer.token, correlationId: s.customer.correlationId, application: s.config.current.application, x: s.util.uuid() });
        }), this.hasInstalled = !0;
      } catch (o) {
        return this.onFault(o), !1;
      }
    },
    pub: function() {
      var a = this, s = { addMetadata: this.metadata.addMetadata, attempt: function(o, l) {
        try {
          var h = Array.prototype.slice.call(arguments, 2);
          return o.apply(l || this, h);
        } catch (w) {
          throw a.onError("catch", w), d.wrapError(w);
        }
      }, configure: function(o) {
        return !a.hasInstalled && a.hasEnabled ? (a.warn("agent must be installed"), !1) : a.config.setCurrent(o);
      }, hash: "ee2d3930f78cfd8bb97c23558688dedfac2d12ce", isInstalled: function() {
        return a.hasInstalled;
      }, install: this.install, removeMetadata: this.metadata.removeMetadata, track: function(o) {
        if (!a.hasInstalled && a.hasEnabled) a.warn("agent must be installed");
        else {
          var l = d.isError(o) ? o.message : a.serialize(o);
          if (o = o || {}, !o.stack) try {
            throw Error(l);
          } catch (h) {
            o = h;
          }
          a.onError("direct", o);
        }
      }, version: "3.10.4", watch: function(o, l) {
        return function() {
          try {
            var h = Array.prototype.slice.call(arguments, 0);
            return o.apply(l || this, h);
          } catch (w) {
            throw a.onError("catch", w), d.wrapError(w);
          }
        };
      }, watchAll: function(o) {
        var l = Array.prototype.slice.call(arguments, 1), h;
        for (h in o) typeof o[h] != "function" || d.contains(l, h) || (o[h] = this.watch(o[h], o));
        return o;
      } };
      return new u(
        d,
        a.log,
        a.onError,
        a.onFault,
        a.serialize,
        s,
        i.prototype.defaults.console
      ), s;
    },
    onError: /* @__PURE__ */ function() {
      var a, s = !1;
      return function(o, l, h) {
        if (this.hasInstalled && this.hasEnabled && d.isBrowserSupported()) try {
          if (h = h || { bindStack: null, bindTime: null, force: !1 }, l && d.isError(l) || (l = { name: "Error", message: this.serialize(l, h.force) }), l.message.indexOf("TrackJS Caught") === -1) if (s && l.message.indexOf("Script error") !== -1) s = !1;
          else {
            var w = d.defaultsDeep({}, { agentPlatform: d.isBrowser ? "browser" : "worker", bindStack: h.bindStack, bindTime: h.bindTime, column: l.column || l.columnNumber, console: this.windowConsoleWatcher.report(), customer: this.customer.report(), entry: o, environment: this.environment.report(), file: l.file || l.fileName, line: l.line || l.lineNumber, message: l.message, metadata: this.metadata.report(), nav: this.navigationWatcher.report(), network: this.networkWatcher.report(), url: (e.location || "").toString(), stack: l.stack, timestamp: this.util.isoNow(), visitor: this.visitorWatcher.report(), version: "3.10.4" });
            if (!h.force) try {
              if (!this.config.current.onError(w, l)) return;
            } catch (P) {
              w.console.push({
                timestamp: this.util.isoNow(),
                severity: "error",
                message: P.message
              });
              var m = this;
              setTimeout(function() {
                m.onError("catch", P, { force: !0 });
              }, 0);
            }
            if (this.config.current.dedupe) {
              var O = (w.message + w.stack).substr(0, 1e4);
              if (O === a) return;
              a = O;
            }
            (function() {
              function P() {
                var A = 0;
                return d.forEach(w.console, function(M) {
                  A += (M.message || "").length;
                }), 8e4 <= A;
              }
              for (var D = 0; P() && D < w.console.length; ) w.console[D].message = d.truncate(w.console[D].message, 1e3), D++;
            })(), this.log.clear(), setTimeout(function() {
              s = !1;
            }), s = !0, this.transmitter.sendError(w, this.customer.token);
          }
        } catch (P) {
          this.onFault(P);
        }
      };
    }(),
    onFault: function(a) {
      var s = this.transmitter || new p();
      a = a || {}, a = { token: (this.customer || {}).token, file: a.file || a.fileName, msg: a.message || "unknown", stack: (a.stack || "unknown").substr(0, 1e3), url: this.window.location, v: "3.10.4", h: "ee2d3930f78cfd8bb97c23558688dedfac2d12ce", x: this.util.uuid() }, s.sendTrackerFault(a);
    },
    serialize: function(a, s) {
      if (this.hasInstalled && this.config.current.serialize && !s) try {
        return this.config.current.serialize(a);
      } catch (o) {
        this.onError("catch", o, { force: !0 });
      }
      return i.prototype.defaults.serialize(a);
    },
    warn: function(a) {
      d.has(e, "console.warn") && e.console.warn("TrackJS: " + a);
    }
  }, new T().pub();
}(typeof self > "u" ? void 0 : self, typeof document > "u" ? void 0 : document);
class Mc extends Jt {
  constructor() {
    super(...arguments);
    N(this, "token");
    N(this, "application");
    N(this, "network");
    N(this, "visitor");
  }
  init(r) {
    this.isStartedInit || (this.token = r.token, r.application && (this.application = r.application), r.network && (this.network = r.network), r.visitor && (this.visitor = r.visitor), this.baseInit(r.timeoutMS));
  }
  install() {
    if (!this.token)
      throw new Lt("ErrorLogger requires a token parameter", {
        serviceName: V.ERROR_LOGGER
      });
    Ht.install({
      token: this.token,
      application: this.application,
      ...this.network && { network: this.network },
      ...this.visitor && { visitor: this.visitor }
    });
  }
  isInstalled() {
    return Ht.isInstalled();
  }
  track(r) {
    this.enqueueOrExecute(() => Ht.track(r));
  }
  log(r, ...n) {
    this.enqueueOrExecute(() => Ht.console[r](...n));
  }
  addMeta(r, n) {
    this.enqueueOrExecute(() => Ht.addMetadata(r, n));
  }
}
var hr = /* @__PURE__ */ ((e) => (e.PageView = "pageView", e.ReachGoal = "reachGoal", e))(hr || {});
class Dc extends Jt {
  constructor() {
    super(...arguments);
    N(this, "counterId");
  }
  init(r) {
    this.isStartedInit || (this.counterId = r.id, this.baseInit(r.timeoutMS));
  }
  install() {
    if (!this.counterId)
      throw new Lt("VkAnalyticsProvider requires a counterId parameter", {
        serviceName: V.VK
      });
    wr(Cc, {
      onload: () => {
        window._tmr = window._tmr || [];
      }
    }), this.addCounterImageToBody();
  }
  addCounterImageToBody() {
    const r = document.createElement("noscript"), n = document.createElement("div"), i = Object.assign(document.createElement("img"), {
      src: `${Fc}?id=${this.counterId};js=na`,
      style: "border:0;position:absolute;left:-9999px;",
      alt: "Top.Mail.Ru"
    });
    n.append(i), r.append(n), document.body.append(r);
  }
  isInstalled() {
    return !!window._tmr;
  }
  hit(r) {
    this.enqueueOrExecute(
      () => window._tmr.push({
        id: this.counterId,
        type: hr.PageView,
        ...r
      })
    );
  }
  reachGoal(r, n) {
    this.enqueueOrExecute(
      () => window._tmr.push({
        id: this.counterId,
        type: hr.ReachGoal,
        goal: r,
        ...n
      })
    );
  }
}
const Ic = {
  [V.ADRIVER]: wu,
  [V.TRACKER]: Pc,
  [V.METRIKA]: Ac,
  [V.ERROR_LOGGER]: Mc,
  [V.VK]: Dc
}, Wa = 6e4, Nc = 3e3, jc = "https://content.adriver.ru/AdRiverFPS.js", _c = "//mc.yandex.ru/metrika/watch.js", Rc = "metrikaDataLayer", Cc = "https://top-fwz1.mail.ru/js/code.js", Fc = "https://top-fwz1.mail.ru/counter";
var La, Ua, Ga, qa, $a;
$a = V.ADRIVER, qa = V.TRACKER, Ga = V.METRIKA, Ua = V.ERROR_LOGGER, La = V.VK;
class bl {
  constructor(t) {
    N(this, $a);
    N(this, qa);
    N(this, Ga);
    N(this, Ua);
    N(this, La);
    Object.entries(Ic).forEach(([r, n]) => {
      gu(() => {
        t[r] && (this[r] = new n(), this[r].init(t[r]));
      });
    });
  }
}
export {
  bl as Analytics,
  Lt as AnalyticsError,
  Qo as ApiService,
  rt as Breakpoint,
  hl as KEY_ENTER,
  pl as KEY_ESCAPE,
  yl as KEY_SPACE,
  ml as KEY_TAB,
  be as NetworkError,
  V as ServiceName,
  Qc as addDaysToDate,
  Xc as addMonthsToDate,
  Jc as addYearsToDate,
  $c as apiService,
  gl as debounce,
  gu as deferExecution,
  Zc as formatDate,
  ll as formatMoney,
  fl as formatPhone,
  Kc as formatToISO,
  Yc as getCalendarSpreadDates,
  sl as getDateDifference,
  ul as getDurationParts,
  zc as getEndOfDay,
  Vc as getEndOfMonth,
  tl as getMonthIndex,
  Bc as getStartOfDay,
  Hc as getStartOfMonth,
  vl as hasSlotContent,
  el as isSameDay,
  rl as isSameMonth,
  nl as isSameYear,
  wr as loadExternalScript,
  il as parseDate,
  dl as pluralize,
  cl as setBodyOverflow,
  al as setMonthForDate,
  ol as setYearForDate,
  wl as throttle,
  Gc as useTimer,
  qc as useViewport
};
